!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var a = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(r, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 66);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("@material-ui/core");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return h;
  });
  var r = n(0),
      a = n(1),
      o = n(7),
      i = n.n(o);

  function l(e) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function d(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function m(e, t) {
    return (m = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function p(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = f(e);

      if (t) {
        var a = f(this).constructor;
        n = Reflect.construct(r, arguments, a);
      } else n = r.apply(this, arguments);

      return g(this, n);
    };
  }

  function g(e, t) {
    return !t || "object" !== l(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function f(e) {
    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var v = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && m(e, t);
    }(l, e);
    var t,
        n,
        a,
        o = p(l);

    function l(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), (t = o.call(this, e)).state = {
        play: !1
      }, t;
    }

    return t = l, (n = [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        setTimeout(function () {
          e.setState({
            play: !0
          });
        }, this.props.timeout || 0);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.children,
            a = t.classes,
            o = t.direction,
            l = t.delay,
            c = t.renderFor;
        return r.createElement(r.Fragment, null, "print" === c ? n : n && r.Children.map(n, function (t) {
          return t ? r.cloneElement(t, {
            style: s(s({}, t.props.style || {}), {}, {
              transitionDelay: l + "ms"
            }),
            className: i()(a.root, a[o], e.state.play && a.animate, t.props.className)
          }) : "";
        }));
      }
    }]) && d(t.prototype, n), a && d(t, a), l;
  }(r.PureComponent),
      h = Object(a.withStyles)(function (e) {
    return {
      root: {
        opacity: 0,
        transition: "opacity 0.5s ease-out, transform 0.5s ease-out"
      },
      up: {
        transform: "translate(0%, -100px)"
      },
      down: {
        transform: "translate(0%, 100px)"
      },
      left: {
        transform: "translate(-100px, 0%)"
      },
      right: {
        transform: "translate(100px, 0%)"
      },
      animate: {
        opacity: 1,
        transform: "translate(0%, 0%)"
      }
    };
  })(v);
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });
  var r = n(0);

  function a(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function i(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          a = !1,
          o = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        a = !0, o = e;
      } finally {
        try {
          r || null == l.return || l.return();
        } finally {
          if (a) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return l(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function l(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function c(e, t) {
    var n = i(Object(r.useState)(e), 2),
        l = n[0],
        c = n[1];
    return function (e, n) {
      return {
        value: l[e] || n,
        update: function update(n) {
          l[e] = n, c(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? a(Object(n), !0).forEach(function (t) {
                o(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }({}, l)), t(l);
        }
      };
    };
  }
}, function (e, t) {
  e.exports = require("@fortawesome/react-fontawesome");
}, function (e, t) {
  e.exports = require("@coderehab/greenzeen-themes");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(13),
      o = n(20),
      i = n(5);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.print,
        n = e.element,
        l = e.components;
    if (!(n = c({}, n)) || !n.component) return null;
    var s = Object(i.useTheme)().elementConfig[n.component],
        u = c(c(c(c({}, a.b), o.a.config.components || {}), l || {}), t ? a.c : {})[n.component];
    return n.config = c(c({}, s && s.config || {}), n.config), u ? r.createElement(u, {
      element: n
    }) : null;
  };
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t) {
  e.exports = require("react-router-dom");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "c", function () {
    return i;
  }), n.d(t, "b", function () {
    return l;
  }), n.d(t, "a", function () {
    return c;
  }), n.d(t, "d", function () {
    return s;
  });

  var o = function o(e) {
    return e && "string" == typeof e ? JSON.parse(e) : e;
  },
      i = function i(e) {
    var t = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? r(Object(n), !0).forEach(function (t) {
          a(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e);

    return t.config = o(e.config) || o(e.props), t;
  },
      l = function l(e) {
    return e.layout || {
      i: e.id,
      x: 0,
      y: 0,
      w: 12,
      h: 10
    };
  };

  function c(e) {
    var t = i(e);
    return t.animation = e.animation || {
      duration: 0,
      delay: 0
    }, t.breakpoint = (e.breakpoint || []).map(function (e) {
      return i(e);
    }), t.layout = l(t), t;
  }

  function s() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return c(e);
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });

  var r = function r() {
    return !1;
  };
}, function (e, t) {
  e.exports = require("@coderehab/greenzeen-media-library");
}, function (e, t) {
  e.exports = require("react-json-editor-ajrm");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return P;
  }), n.d(t, "b", function () {
    return R;
  }), n.d(t, "c", function () {
    return W;
  });
  var r = n(25),
      a = n(26),
      o = n(27),
      i = n(15),
      l = n(24),
      c = n(28),
      s = n(18),
      u = n(17),
      d = n(23),
      m = n(29),
      p = n(22),
      g = n(30),
      f = n(31),
      v = n(19),
      h = n(0),
      b = n(1),
      y = n(7),
      k = n.n(y),
      E = n(36),
      j = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0 20px",
      borderLeft: "3px solid #ddd"
    },
    content: {
      fontStyle: "italic"
    },
    author: {
      display: "block",
      marginTop: "-1em",
      fontStyle: "normal"
    }
  }),
      O = n(4),
      w = n(37),
      z = n(38),
      x = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0"
    }
  }),
      T = n(14);

  function S() {
    return (S = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var P,
      C = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0 20px",
      borderLeft: "3px solid #ddd"
    }
  }),
      D = n(8),
      F = Object(b.makeStyles)({
    root: {},
    item: {
      "& *": {
        color: "inherit"
      }
    }
  }),
      B = n(5),
      M = Object(b.makeStyles)({
    root: {
      paddingBottom: 0,
      marginBottom: "10px !important"
    },
    step: {
      marginBottom: "20px !important",
      fontWeight: 600
    },
    title: {
      marginBottom: "0 !important"
    },
    description: {
      marginTop: "5px !important"
    }
  }),
      A = function A(e) {
    e.element;
    return null;
  },
      I = n(32),
      N = n(33);

  !function (e) {
    e.Typography = "Typography", e.Quote = "Quote", e.ReadTime = "ReadTime", e.Video = "Video", e.Image = "Image", e.Media = "Media", e.WistJeDat = "WistJeDat", e.Divider = "Divider", e.Author = "Author", e.List = "List", e.Paper = "Paper", e.CoverButton = "CoverButton", e.Button = "Button", e.Popup = "Popup", e.Index = "Index";
  }(P || (P = {}));
  var R = {
    Typography: r.a,
    Quote: a.a,
    Image: i.a,
    Author: o.a,
    Paper: l.a,
    Video: c.a,
    ReadTime: s.a,
    Media: u.a,
    List: d.a,
    Divider: m.a,
    CoverButton: g.a,
    WistJeDat: p.a,
    Button: f.a,
    Popup: I.a,
    Index: N.a
  },
      W = {
    Typography: v.a,
    Quote: function Quote(e) {
      var t = e.element.config,
          n = t.author,
          r = t.dash,
          a = t.content,
          o = j();
      return h.createElement("div", {
        className: o.root
      }, h.createElement(b.Typography, {
        className: o.content
      }, '"', a, '"'), n && h.createElement(b.Typography, null, h.createElement("small", {
        className: o.author
      }, r ? "-" : "", " ", n)));
    },
    ReadTime: function ReadTime(e) {
      var t = e.element.config,
          n = t.time,
          r = t.category,
          a = Object(z.a)();
      return h.createElement("div", {
        className: a.root,
        style: {
          justifyContent: "align",
          flexWrap: "wrap"
        }
      }, h.createElement(b.Typography, {
        variant: "body2",
        component: "span"
      }, r), n && h.createElement(h.Fragment, null, h.createElement(O.FontAwesomeIcon, {
        className: a.icon,
        icon: w.faClock
      }), h.createElement(b.Typography, {
        variant: "body2",
        component: "span"
      }, "Leestijd: ", n)));
    },
    Media: function Media(e) {
      var t = e.element,
          n = Object(E.a)(),
          r = t.config,
          a = (t.animation, r.className),
          o = r.maxWidth,
          i = (r.image, r.embed, r.width, r.height, r.caption),
          l = r.children;
      return h.createElement("div", {
        className: k()(n.root, a),
        style: {
          maxWidth: o || "100%"
        }
      }, h.createElement("div", {
        className: n.inner
      }, i && h.createElement(b.Typography, {
        variant: "caption",
        className: n.blurb
      }, i), l));
    },
    Video: function Video(e) {
      e.element;
      return null;
    },
    Image: function Image(e) {
      var t = e.element.config.src;
      return h.createElement("img", {
        src: t,
        style: {
          maxWidth: "100%"
        }
      });
    },
    Author: function Author(e) {
      var t = e.element.config,
          n = x(),
          r = (t.avatar, t.credits);
      return h.createElement("div", {
        className: n.root
      }, h.createElement(b.Typography, {
        variant: "body2"
      }, r.map(function (e, t) {
        return h.createElement("span", {
          key: t,
          style: {
            display: "block"
          }
        }, h.createElement("b", null, e.credit, ": "), e.name);
      })));
    },
    Paper: function Paper(e) {
      var t = e.element.config,
          n = t.paper,
          r = t.layoutConfig,
          a = C(),
          o = t.data.map(function (e) {
        return e;
      });
      return h.createElement(b.Paper, S({
        elevation: 0,
        className: a.root
      }, n), h.createElement(T.a, {
        config: JSON.parse(r || "{}"),
        data: o || []
      }));
    },
    List: function List(e) {
      var t = e.element.config,
          n = t.items,
          r = t.variant,
          a = F();
      return h.createElement("div", {
        className: a.root
      }, n.map(function (e, t) {
        var n = e.href || "",
            a = {};
        return n ? ("big" !== r && (a.dense = !0), n && (a.button = !0), h.createElement("div", null, h.createElement(b.Typography, {
          style: {
            marginBottom: 5
          }
        }, " ", h.createElement("strong", null, e.primary), "         "), h.createElement(b.Typography, {
          style: {
            marginTop: 0
          }
        }, "   ", e.secondary, " "), h.createElement(D.Link, {
          to: e.href
        }, " ", h.createElement("small", null, " ", e.href), "  "))) : null;
      }));
    },
    WistJeDat: function WistJeDat(e) {
      var t = e.element.config,
          n = (Object(B.useTheme)().fonts, t.step),
          r = t.title,
          a = t.description,
          o = M();
      return h.createElement("div", {
        className: o.root
      }, h.createElement(b.Typography, {
        variant: "h6",
        className: o.step
      }, n), h.createElement(b.Typography, {
        className: o.title,
        variant: "h6",
        style: {
          fontWeight: "normal"
        }
      }, h.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: r
        }
      })), h.createElement(b.Typography, {
        className: o.description
      }, h.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: a
        }
      })));
    },
    Button: A,
    Index: A
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  var r = n(0),
      a = n(1),
      o = n(6);

  function i() {
    return (i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var l = function l(e) {
    var t = e.data;
    return r.createElement("div", null, r.createElement(a.Grid, i({
      container: !0,
      spacing: 4
    }, t.container), t.sections.map(function (e, t) {
      return r.createElement(a.Grid, i({
        key: t,
        item: !0,
        xs: !0
      }, e.props || {}), e.data.map(function (e, n) {
        return r.createElement(o.a, {
          key: t + "-" + n,
          element: e
        });
      }));
    })));
  };

  function c() {
    return (c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var s = function s(e) {
    var t = e.data;
    return !0 === t.container.print ? r.createElement(a.Grid, {
      container: !0,
      spacing: 1
    }, t.sections.map(function (e) {
      return r.createElement(a.Grid, c({
        item: !0,
        xs: 12
      }, e.props || {}), e.data.map(function (e) {
        return r.createElement(o.a, {
          element: e
        });
      }));
    })) : t.sections.map(function (e) {
      return e.data.map(function (e) {
        return r.createElement(o.a, {
          element: e
        });
      });
    });
  };

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var d = function d(e) {
    var t = e.data;
    return r.createElement(a.Grid, {
      container: !0,
      spacing: t.container.mobileSpacing || 0
    }, t.sections.map(function (e) {
      return r.createElement(a.Grid, u({
        item: !0,
        xs: 12
      }, e.props || {}), e.data.map(function (e) {
        return r.createElement(o.a, {
          element: e
        });
      }));
    }));
  };

  function m(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function p(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? m(Object(n), !0).forEach(function (t) {
        g(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function g(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var f = function f(e) {
    var t = e.config,
        n = e.data,
        a = e.renderFor;
    n.forEach(function (e, t) {
      e.animation = {
        duration: 700,
        delay: 50 * t
      };
    });
    var o = Object.keys(t).length && {
      container: t.container || {},
      sections: Object.keys(t.sections).map(function (e) {
        var r = n.filter(function (t) {
          return t.section === e;
        });
        return p(p({}, t.sections[e]), {}, {
          section: e,
          data: r
        });
      })
    } || {
      container: {},
      sections: [{
        data: n,
        section: "main"
      }]
    };
    return r.createElement(r.Fragment, null, "desktop" === a && r.createElement(l, {
      data: o
    }), "mobile" === a && r.createElement(d, {
      data: o
    }), "print" === a && r.createElement(s, {
      data: o
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });

  var r = n(0),
      a = n(1),
      o = n(2),
      i = n(8),
      l = n(35),
      c = function c(e) {
    var t = e.element,
        n = t.config,
        c = t.animation,
        s = n.url,
        u = n.target,
        d = n.styles,
        m = n.mobilesrc,
        p = n.shadow,
        g = n.src,
        f = n.caption,
        v = n.map,
        h = Object(l.a)();
    return r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, "" !== v ? r.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: v
      }
    }) : "", s ? r.createElement("figure", {
      className: h.root,
      style: d || {}
    }, s.includes("https://") || s.includes("https://") || s.includes("mailto:") ? r.createElement("a", {
      href: s,
      target: u ? "_blank" : ""
    }, r.createElement("picture", null, m && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: m
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: g,
      className: h.image,
      style: {
        boxShadow: p ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      },
      useMap: v ? "#workmap" : ""
    }))) : r.createElement(i.NavLink, {
      to: s,
      className: h.imgHover
    }, r.createElement("picture", null, m && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: m
    }), r.createElement("img", {
      id: "image",
      alt: "",
      useMap: v ? "#workmap" : "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: g,
      className: h.image,
      style: {
        boxShadow: p ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      }
    }))), f && r.createElement(a.Typography, {
      variant: "caption",
      className: h.caption
    }, f)) : r.createElement("figure", {
      className: h.root,
      style: d || {}
    }, r.createElement("picture", null, m && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: m
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: g,
      style: {
        boxShadow: p ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      },
      className: h.image,
      useMap: v ? "#workmap" : ""
    })), f && r.createElement(a.Typography, {
      variant: "caption",
      className: h.caption
    }, f)));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(1),
      o = n(3),
      i = n(11);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element,
        n = e.onChange,
        l = Object(o.a)(t.config, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        s = l("caption", ""),
        u = l("mobilesrc", ""),
        d = l("shadow", ""),
        m = l("src", ""),
        p = l("target", ""),
        g = l("url", ""),
        f = l("map", "");
    return r.createElement(r.Fragment, null, r.createElement(i.FileSelector, {
      value: {
        href: m.value
      },
      onChange: function onChange(e) {
        return m.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(i.FileSelector, {
      value: {
        href: u.value
      },
      onChange: function onChange(e) {
        return u.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Caption",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "URL",
      value: g.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return g.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "map",
      value: f.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return f.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.FormControlLabel, {
      control: r.createElement(a.Checkbox, {
        checked: !!d.value,
        onChange: function onChange() {
          return d.update(!d.value);
        }
      }),
      label: "Shadow",
      labelPlacement: "end"
    }), r.createElement(a.FormControlLabel, {
      control: r.createElement(a.Checkbox, {
        checked: !!p.value,
        onChange: function onChange() {
          return p.update(!p.value);
        }
      }),
      label: "Open in new tab?",
      labelPlacement: "end"
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });

  var r = n(0),
      a = n(1),
      o = n(7),
      i = n.n(o),
      l = n(2),
      c = n(36),
      s = function s(e) {
    var t = e.element,
        n = Object(c.a)(),
        o = t.config,
        s = t.animation,
        u = o.className,
        d = o.maxWidth,
        m = o.image,
        p = o.embed,
        g = o.width,
        f = o.height,
        v = o.caption,
        h = o.children;
    return r.createElement(l.a, {
      renderFor: "print",
      direction: "up",
      timeout: s.duration,
      delay: s.delay
    }, r.createElement("div", {
      className: i()(n.root, u),
      style: {
        maxWidth: d || "100%"
      }
    }, r.createElement("div", {
      className: n.inner
    }, m && !p && r.createElement("img", {
      width: g || "unset",
      height: f || "unset",
      src: m,
      className: n.media,
      alt: ""
    }), p && r.createElement("div", {
      className: n.videoWrapper
    }, r.createElement("iframe", {
      title: p,
      width: g,
      allowFullScreen: !0,
      height: f,
      src: p,
      className: i()(n.media, n.video)
    })), v && r.createElement(a.Typography, {
      variant: "caption",
      className: n.blurb
    }, v), h)));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });

  var r = n(0),
      a = n(1),
      o = n(4),
      i = n(37),
      l = n(2),
      c = n(38),
      s = n(10),
      u = function u(e) {
    var t = e.element,
        n = t.config,
        u = t.animation,
        d = n.time,
        m = n.category,
        p = n.align,
        g = Object(c.a)(),
        f = Object(s.a)();
    return r.createElement(r.Fragment, null, f ? r.createElement(a.Typography, {
      variant: "body2"
    }, m, " ", d && " - Leestijd: ".concat(d)) : r.createElement(l.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: u.duration,
      delay: u.delay
    }, r.createElement("div", {
      className: g.root,
      style: {
        justifyContent: p,
        flexWrap: "wrap"
      }
    }, r.createElement(a.Typography, {
      variant: "body2"
    }, m), d && r.createElement(r.Fragment, null, r.createElement(o.FontAwesomeIcon, {
      className: g.icon,
      icon: i.faClock
    }), r.createElement(a.Typography, {
      variant: "body2"
    }, "Leestijd: ", d)))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      a = n(1),
      o = n(5);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element.config,
        n = Object(o.useTheme)().fonts,
        i = t.variant,
        c = t.customStyle,
        s = (t.gutterBottom, t.paragraph, t.align, t.font),
        u = t.fontWeight,
        d = t.children,
        m = n[s || ""] && n[s || ""].fontFamily;
    return r.createElement(a.Typography, {
      variant: i,
      align: "left",
      style: l(l(l(l({}, c), m ? {
        fontFamily: m
      } : {}), u ? {
        fontWeight: u
      } : {}), {}, {
        color: "inherit"
      })
    }, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: d
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function a(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? r(Object(n), !0).forEach(function (t) {
        o(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "a", function () {
    return l;
  });
  var i = {
    tenant: "default",
    components: {}
  },
      l = {
    configure: function configure(e) {
      i = a(a({}, i), e);
    },

    get config() {
      return i;
    }

  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  var r = {
    default: n(34).a
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(1),
      o = n(2),
      i = n(62);

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var c = Object(i.withStyles)(function (e) {
    var t;
    return {
      root: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        transition: "height 0.1s, width 0.1s"
      },
      header: {
        display: "flex",
        position: "relative",
        alignItems: "flex-end",
        width: "100%",
        padding: "0 20px"
      },
      image: {
        maxWidth: "100%",
        marginBottom: "-20%",
        marginLeft: "-20px",
        padding: "0 20px"
      },
      montserrat: {
        fontWeight: "bold",
        fontFamily: "Montserrat"
      },
      title: {
        display: "inline-block",
        maxWidth: "max-content",
        maxHeight: "fit-content",
        padding: e.spacing(1, 2),
        clipPath: "polygon(0% 10%, 100% 0%, 98% 100%, 2% 100%)",
        margin: "0 auto -25px auto",
        zIndex: 2,
        flexShrink: 0,
        "& *": {
          fontWeight: 500,
          margin: "0 !important"
        },
        transition: "height 0.1s, width 0.1s"
      },
      body: {
        color: "inherit",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        maxWidth: 460,
        margin: "0 auto",
        transition: "height 0.1s, width 0.1s"
      },
      subtitleWrapper: (t = {
        height: "auto",
        width: "100%",
        backgroundColor: "white",
        padding: e.spacing(3, 2, 2, 2)
      }, l(t, e.breakpoints.up("md"), {
        padding: e.spacing(3, 2, 2, 2)
      }), l(t, "display", "flex"), l(t, "justifyContent", "center"), l(t, "alignItems", "center"), l(t, "clipPath", "polygon(0% 3%, 100% 0%, 96% 100%, 2% 100%)"), l(t, "color", "#4a4a4a"), l(t, "marginBottom", e.spacing(2)), l(t, "transition", "height 0.1s, width 0.1s"), t),
      subtitle: {
        maxWidth: 460,
        margin: "0 auto"
      }
    };
  })(function (e) {
    var t = e.classes,
        n = e.title,
        i = e.children,
        l = e.color,
        c = e.subtitle,
        s = e.titleColor,
        u = e.image,
        d = e.renderFor;
    return r.createElement(r.Fragment, null, "desktop" === d && r.createElement("div", {
      className: t.root
    }, r.createElement("header", {
      className: t.header
    }, r.createElement("div", {
      className: t.title,
      style: {
        backgroundColor: l,
        color: s
      }
    }, r.createElement(o.a, {
      renderFor: d,
      direction: "up",
      timeout: 500
    }, n)), r.createElement(o.a, {
      renderFor: d,
      direction: "down",
      timeout: 700
    }, r.createElement("div", {
      style: {
        overflowY: "hidden"
      }
    }, r.createElement(a.Hidden, {
      smDown: !0
    }, r.createElement("img", {
      className: t.image,
      src: u,
      alt: ""
    }))))), r.createElement("div", {
      className: t.subtitleWrapper
    }, r.createElement(o.a, {
      renderFor: d,
      direction: "up",
      timeout: 900
    }, r.createElement("div", {
      className: t.subtitle
    }, c))), r.createElement("div", {
      className: t.body
    }, r.createElement(o.a, {
      renderFor: d,
      direction: "up",
      timeout: 1100
    }, i))), "print" === d && r.createElement("div", null, n, c, i));
  });

  var s = Object(a.makeStyles)(function (e) {
    return {
      root: (t = {}, n = e.breakpoints.down("sm"), r = {
        padding: e.spacing(3, 0)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      secondary: {
        fontFamily: "Montserrat",
        fontWeight: 500
      },
      articleCoverTitle: {
        "&$secondary": {
          fontWeight: 300
        }
      },
      title: {
        fontWeight: 500
      },
      italic: {
        fontStyle: "italic"
      },
      strong: {
        fontWeight: 700
      },
      fatHeader: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        marginBottom: "1em",
        paddingBottom: "1em",
        borderBottom: "solid 5px"
      }
    };
    var t, n, r;
  }),
      u = function u(e) {
    var t = e.element,
        n = s(),
        i = t.config,
        l = t.animation,
        u = i.stepColor,
        d = i.stepBackground,
        m = i.step,
        p = i.title,
        g = i.description;
    return r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement("div", {
      className: n.root
    }, r.createElement(c, {
      renderFor: "desktop",
      image: "/article/images/vent-turquoise.png",
      color: d,
      titleColor: u,
      title: r.createElement(r.Fragment, null, r.createElement(a.Typography, {
        variant: "h5"
      }, m)),
      subtitle: r.createElement(a.Typography, {
        variant: "h5",
        style: {
          fontStyle: "italic"
        }
      }, r.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: p
        }
      }))
    }, r.createElement(a.Typography, null, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: g
      }
    })))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r = n(61),
      a = n(4),
      o = n(1),
      i = n(7),
      l = n.n(i),
      c = n(0),
      s = n(8),
      u = n(2);
  var d = Object(o.makeStyles)(function (e) {
    return {
      root: {
        paddingTop: 0
      },
      item: {
        paddingLeft: 0,
        "& *": {
          color: "inherit"
        }
      },
      title: (t = {
        fontSize: 25,
        paddingBottom: 20,
        borderBottom: "5px solid",
        lineHeight: "120%"
      }, n = e.breakpoints.down("sm"), r = {
        fontSize: 20
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      big: {},
      primary: {},
      secondary: {}
    };
    var t, n, r;
  });

  function m() {
    return (m = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var p = function p(e) {
    var t = e.element,
        n = t.config,
        i = t.animation,
        p = n.variant,
        g = n.items || [],
        f = n.title,
        v = d();
    return c.createElement(o.List, {
      className: v.root
    }, f ? c.createElement(u.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: i.duration,
      delay: i.delay
    }, c.createElement(o.Typography, {
      className: v.title,
      variant: "h1"
    }, f)) : "", g.map(function (e, t) {
      var n = e.href || "",
          d = {};
      return "big" !== p && (d.dense = !0), n && (d.button = !0), c.createElement(u.a, {
        renderFor: "desktop",
        direction: "up",
        timeout: i.duration,
        delay: i.delay + 75 * t
      }, c.createElement("div", null, c.createElement(o.ListItem, m({
        component: n.startsWith("/") ? s.Link : o.Link,
        href: n,
        to: n,
        target: n.startsWith("/") ? void 0 : "_blank",
        className: l()(v.item, p && v[p]),
        style: {
          borderBottom: g.length > 1 && t + 1 !== g.length ? "1px solid" : "0"
        }
      }, d), e.icon && c.createElement(o.ListItemIcon, null, e.icon && c.createElement(a.FontAwesomeIcon, {
        icon: e.icon
      }) || e.icon), "big" !== p ? c.createElement(o.ListItemText, {
        primary: e.primary,
        secondary: e.secondary
      }) : c.createElement(o.ListItemText, {
        primary: e.primary,
        secondary: e.secondary,
        classes: {
          primary: v.primary,
          secondary: v.secondary
        }
      }), c.createElement(a.FontAwesomeIcon, {
        icon: r.faChevronRight
      }))));
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(1),
      o = n(2),
      i = n(14),
      l = n(10),
      c = Object(a.makeStyles)(function (e) {
    return {
      root: {
        position: "relative",
        overflow: "hidden",
        padding: "30px 65px 30px 35px",
        background: "linear-gradient(-135deg, transparent 40px, white 40px)",
        margin: e.spacing(0, 0, 3, 0)
      },
      cutout: {
        position: "absolute",
        height: "55px",
        width: "55px",
        top: 0,
        right: 0
      }
    };
  });

  function s() {
    return (s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var u = function u(e) {
    var t = e.element,
        n = t.config,
        u = t.animation,
        d = n.paper,
        m = n.layoutConfig,
        p = Object(l.a)(),
        g = c(),
        f = "linear-gradient(-135deg, transparent 40px, " + (n.cutoutColor || "#ff6c7b") + " 40px)",
        v = n.data.map(function (e) {
      return e.props = JSON.parse(e.props), e;
    });
    return p ? r.createElement(i.a, {
      config: JSON.parse(m || "{}"),
      data: v || []
    }) : r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: u.duration,
      delay: u.delay
    }, r.createElement(a.Paper, s({
      elevation: 0,
      className: g.root
    }, d), r.createElement("div", {
      className: g.cutout,
      style: {
        background: f
      }
    }), r.createElement(i.a, {
      config: JSON.parse(m || "{}"),
      data: v || []
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  var r = n(0),
      a = n(1),
      o = n(2),
      i = Object(a.makeStyles)(function (e) {
    return {
      root: {}
    };
  }),
      l = n(5),
      c = n(7),
      s = n.n(c);

  function u(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function p(e) {
    return function (e) {
      if (Array.isArray(e)) return g(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return g(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return g(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function g(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var f = function f(e) {
    var t = e.element,
        n = t.config,
        c = t.animation,
        u = i(),
        m = Object(l.useTheme)().fonts,
        g = n.variant,
        f = n.style,
        v = n.customStyle,
        h = n.gutterBottom,
        b = n.paragraph,
        y = n.align,
        k = n.font,
        E = n.color,
        j = n.fontWeight,
        O = n.children,
        w = n.endItem,
        z = n.endColor,
        x = (n.classNames || []).map(function (e) {
      return u[e];
    }),
        T = "string" == typeof f ? JSON.parse(f) : f,
        S = m[k || ""] && m[k || ""].fontFamily;
    return r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, r.createElement(a.Typography, {
      variant: g,
      align: y || "left",
      paragraph: b,
      gutterBottom: h,
      className: s.a.apply(void 0, [u.root].concat(p(x), [k || ""])),
      style: d(d(d(d(d({}, v), T), S ? {
        fontFamily: S
      } : {}), j ? {
        fontWeight: j
      } : {}), E ? {
        color: E
      } : {})
    }, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: O
      }
    }), w && r.createElement("img", {
      src: "https://d3m8frrq3asli4.cloudfront.net/mst/end-" + z + ".svg",
      style: {
        position: "relative",
        bottom: -5,
        left: 20
      }
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r = n(7),
      a = n.n(r),
      o = n(0),
      i = n(5),
      l = n(1),
      c = n(2);
  var s = Object(l.makeStyles)(function (e) {
    return {
      root: {
        marginBottom: e.spacing(3)
      },
      lineTop: {
        borderTop: "5px solid",
        paddingTop: 10
      },
      content: {
        fontStyle: "italic"
      },
      icon: (t = {
        fontWeight: 500,
        position: "relative",
        fontSize: "5em",
        marginBottom: -15,
        color: "inherit"
      }, n = e.breakpoints.up("md"), r = {
        fontSize: "2em",
        bottom: -50,
        marginTop: -50,
        marginBottom: 30
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      author: {
        marginTop: e.spacing(1)
      }
    };
    var t, n, r;
  });

  function u(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var p = function p(e) {
    var t = e.element,
        n = t.config,
        r = t.animation,
        u = n.author,
        m = n.dash,
        p = n.content,
        g = n.customStyle,
        f = n.color,
        v = n.authorColor,
        h = n.font,
        b = n.lineTop,
        y = Object(l.makeStyles)(n.classes || {}),
        k = s({
      classes: y()
    }),
        E = (Object(i.useTheme)().fonts[h || "primary"] || {}).fontFamily;
    return o.createElement(c.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: r.duration,
      delay: r.delay
    }, o.createElement("div", {
      className: a()(k.root, b && k.lineTop),
      style: {
        color: f
      }
    }, o.createElement(l.Typography, {
      variant: "h4",
      className: k.icon,
      gutterBottom: !0,
      style: d({}, g)
    }, o.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "quote-left",
      className: "svg-inline--fa fa-quote-left fa-w-16 ",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      color: "inherit",
      style: {
        width: ".5em",
        verticalAlign: "-0.125em",
        marginBottom: 15
      }
    }, o.createElement("path", {
      fill: "currentColor",
      d: "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    }))), o.createElement(l.Typography, {
      variant: "h4",
      className: k.content,
      gutterBottom: !0,
      style: d(d({}, E ? {
        fontFamily: E
      } : {}), g)
    }, p), u ? o.createElement(l.Typography, {
      variant: "body2",
      className: k.author,
      style: d(d(d({}, v ? {
        color: v
      } : {}), E ? {
        fontFamily: E
      } : {}), g)
    }, m ? "-" : "", " ", u) : ""));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });

  var r = n(0),
      a = n(1),
      o = n(2),
      i = Object(a.makeStyles)(function (e) {
    return {
      root: {
        padding: e.spacing(2, 1),
        display: "flex",
        alignItems: "center"
      },
      avatarBubble: {
        position: "relative",
        borderRadius: "100%",
        marginRight: e.spacing(2),
        minWidth: e.spacing(6),
        width: e.spacing(6),
        height: e.spacing(6),
        backgroundColor: "white",
        backgroundPosition: "center",
        backgroundSize: "cover",
        "@media print": {
          display: "none"
        }
      },
      credit: {
        fontFamily: "Montserrat",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "14px",
        "& b": {
          fontWeight: "bold"
        }
      },
      textWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "start"
      }
    };
  }),
      l = n(10),
      c = function c(e) {
    var t = e.element,
        n = t.config,
        c = t.animation,
        s = n.avatar,
        u = n.credits,
        d = n.align,
        m = Object(l.a)(),
        p = i();
    return u && u.length ? r.createElement(r.Fragment, null, m && Array.isArray(u) ? u.map(function (e, t) {
      return r.createElement(a.Typography, {
        variant: "body2",
        className: p.credit
      }, r.createElement("span", {
        key: t,
        style: {
          display: "block"
        }
      }, r.createElement("b", null, e.credit, ": "), e.name));
    }) : r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, r.createElement("div", {
      className: p.root,
      style: {
        justifyContent: d
      }
    }, r.createElement("div", {
      className: p.avatarBubble,
      style: {
        backgroundImage: "url(".concat(s, ")")
      }
    }), r.createElement("div", {
      className: p.textWrapper
    }, r.createElement(a.Typography, {
      variant: "body2",
      className: p.credit
    }, u.map(function (e, t) {
      return r.createElement("span", {
        key: t,
        style: {
          display: "block"
        }
      }, r.createElement("b", null, e.credit, ": "), e.name);
    })))))) : null;
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });

  var r = n(0),
      a = n(1),
      o = n(2),
      i = Object(a.makeStyles)(function (e) {
    return {
      root: {
        display: "flex",
        flexDirection: "column",
        paddingBottom: e.spacing(2),
        width: "100%"
      },
      videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%",
        marginBottom: 15,
        height: 0,
        width: "100%",
        zIndex: 1
      },
      video: {
        marginTop: e.spacing(2),
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#000",
        border: "none"
      },
      caption: {
        marginTop: e.spacing(1),
        paddingLeft: e.spacing(2),
        lineHeight: "2em",
        color: "inherit",
        position: "relative",
        "&::before": {
          content: "''",
          left: "10px",
          top: "-24px",
          zIndex: 2,
          width: 1,
          height: 36,
          backgroundColor: "currentColor",
          position: "absolute"
        }
      }
    };
  }),
      l = function l(e) {
    var t = e.element,
        n = i(),
        l = t.config,
        c = t.animation,
        s = l.embed,
        u = l.caption,
        d = l.maxWidth;
    return r.createElement("div", {
      className: n.root,
      style: {
        maxWidth: d
      }
    }, r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, r.createElement("div", {
      className: n.videoWrapper
    }, r.createElement("iframe", {
      title: "video",
      src: s,
      className: n.video
    })), u ? r.createElement(a.Typography, {
      variant: "caption",
      className: n.caption
    }, u) : ""));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });

  var r = n(0),
      a = n(7),
      o = n.n(a),
      i = n(2),
      l = n(1),
      c = Object(l.makeStyles)(function (e) {
    return {
      line: {
        borderBottom: "5px solid",
        margin: e.spacing(3, 0)
      }
    };
  }),
      s = function s(e) {
    var t = e.element,
        n = c(),
        a = t.config,
        l = t.animation,
        s = a.variant,
        u = a.styles;
    return r.createElement(i.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement("div", {
      className: o()(s && n[s]),
      style: u || {}
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });

  var r = n(0),
      a = n(1),
      o = Object(a.makeStyles)(function (e) {
    return {
      root: {
        padding: e.spacing(0),
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        position: "relative",
        color: "#000",
        backgroundColor: "transparent",
        cursor: "pointer",
        transition: e.transitions.create(["padding", "background"], {
          duration: "0.3s"
        }),
        "&:before": {
          content: '""',
          position: "absolute",
          left: "-5%",
          top: "10%",
          width: "110%",
          height: "100%",
          display: "block",
          background: "#e4e4e400",
          transition: e.transitions.create(["padding", "background"], {
            duration: "0.3s"
          })
        }
      },
      container: {
        transition: "all .3s",
        position: "relative",
        "&:hover": {
          transform: "translateY(-15px)"
        },
        "&:after": {
          content: "''",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9,
          height: "60px",
          width: "100%",
          background: "linear-gradient(0deg, #000, transparent);"
        }
      },
      image: {
        boxShadow: e.shadows[10],
        objectFit: "cover",
        msInterpolationMode: "bicubic",
        minHeight: "1px",
        width: "100%",
        transition: "transform 0.3s ease-out"
      },
      title: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        lineHeight: 1.2,
        zIndex: 12,
        fontFamily: "Montserrat",
        position: "absolute",
        bottom: "20px",
        fontWeight: 600,
        fontSize: "21px",
        color: "#fff",
        padding: "0 20px"
      },
      index: {
        background: "#fff",
        top: "10%",
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        left: e.spacing(-1),
        width: e.spacing(3),
        height: e.spacing(3),
        fontFamily: "Montserrat"
      }
    };
  }),
      i = n(8),
      l = function l(e) {
    var t = e.element,
        n = o(),
        l = t.config,
        c = l.image,
        s = l.title,
        u = l.index,
        d = l.link,
        m = l.style;
    return r.createElement(i.Link, {
      to: d,
      style: {
        display: "block"
      }
    }, r.createElement("div", {
      className: n.root,
      style: m
    }, r.createElement("div", {
      className: n.container
    }, r.createElement("img", {
      className: n.image,
      src: c,
      alt: c
    }), r.createElement("span", {
      className: n.index,
      style: {
        color: "#000"
      }
    }, u), r.createElement(a.Typography, {
      className: n.title
    }, r.createElement("small", null, s)))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });

  var r = n(0),
      a = n(1),
      o = n(2),
      i = n(8),
      l = Object(a.makeStyles)(function (e) {
    return {};
  }),
      c = n(4),
      s = function s(e) {
    var t = e.element,
        n = t.config,
        s = t.animation,
        u = n.text,
        d = n.url,
        m = n.color,
        p = n.blank,
        g = l(),
        f = "internal";
    return d && (f = -1 !== d.indexOf("http://") || -1 !== d.indexOf("https://") ? "external" : "internal"), r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: s.duration,
      delay: s.delay
    }, "external" == f ? r.createElement("a", {
      href: d,
      target: p ? "_blank" : "",
      style: {
        textDecoration: "none"
      }
    }, r.createElement(a.Button, {
      classes: g,
      variant: "contained",
      style: {
        color: "#fff",
        backgroundColor: m
      },
      endIcon: r.createElement(c.FontAwesomeIcon, {
        style: {
          color: "#fff"
        },
        icon: "chevron-right"
      }),
      id: "btn-external"
    }, u)) : r.createElement(a.Button, {
      classes: g,
      variant: "contained",
      style: {
        color: "#fff",
        backgroundColor: m
      },
      component: i.Link,
      to: d,
      endIcon: r.createElement(c.FontAwesomeIcon, {
        style: {
          color: "#fff"
        },
        icon: "chevron-right"
      }),
      id: "btn-internal"
    }, u));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r = n(0),
      a = n(1),
      o = n(2);
  var i = Object(a.makeStyles)(function (e) {
    return {
      root: {
        display: "flex",
        alignItems: "center"
      },
      content: {
        fontStyle: "italic"
      },
      popup: {
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(5px)"
      },
      main: {
        backgroundColor: "#fff",
        maxWidth: 850,
        padding: 60,
        position: "relative"
      },
      closeBtn: {
        color: "#fff",
        position: "absolute",
        right: -105,
        top: 70,
        transform: "rotate(-90deg)",
        backgroundColor: "transparent",
        fontSize: "1.2em",
        transition: "all .3s",
        textShadow: "1px 1px 8px #000",
        "&:hover, &:active, &:focus": {
          backgroundColor: "transparent",
          color: "#000"
        }
      },
      openBtn: {
        backgroundColor: "#3dbcbd",
        color: "#fff",
        fontFamily: "Montserrat",
        fontSize: 15,
        fontWeight: 700,
        "&:hover": {
          backgroundColor: "#007d85",
          color: "#fff"
        }
      },
      backDrop: {
        backdropFilter: "blur(4px)",
        backgroundColor: "rgba(244,244,244,0.5)"
      },
      paper: (t = {
        overflowY: "unset",
        padding: e.spacing(4),
        right: 20
      }, n = e.breakpoints.down("md"), r = {
        padding: e.spacing(0)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      dialog: {}
    };
    var t, n, r;
  }),
      l = n(63),
      c = n.n(l),
      s = n(39),
      u = n(40);

  function d(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          a = !1,
          o = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        a = !0, o = e;
      } finally {
        try {
          r || null == l.return || l.return();
        } finally {
          if (a) throw o;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return m(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return m(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function m(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var p = function p(e) {
    var t = e.element,
        n = t.config,
        l = t.animation,
        m = n.buttonText,
        p = n.popupItem,
        g = n.align,
        f = n.yellow,
        v = Object(a.makeStyles)(n.classes || {}),
        h = i({
      classes: v()
    }),
        b = d(r.useState(!1), 2),
        y = b[0],
        k = b[1],
        E = u.a[p];
    return r.createElement(r.Fragment, null, r.createElement(a.Dialog, {
      className: h.dialog,
      open: y,
      onClose: function onClose() {
        return k(!1);
      },
      BackdropProps: {
        className: h.backDrop
      },
      PaperProps: {
        className: h.paper
      },
      maxWidth: "md"
    }, r.createElement(a.DialogContent, null, r.createElement(a.Button, {
      endIcon: r.createElement(c.a, {
        style: {
          fontSize: "1.8em"
        }
      }),
      className: h.closeBtn,
      onClick: function onClick() {
        return k(!1);
      }
    }, "sluit venster"), r.createElement(E, null))), r.createElement(o.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement("div", {
      className: h.root,
      style: {
        justifyContent: g
      }
    }, r.createElement(a.Button, {
      style: {
        backgroundColor: f ? "#EAAB00" : "#3DBCBD"
      },
      endIcon: r.createElement(s.ChevronRight, null),
      variant: "contained",
      className: h.openBtn,
      onClick: function onClick() {
        return k(!0);
      }
    }, m))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });
  var r = n(0),
      a = n(1);

  var o = Object(a.makeStyles)(function (e) {
    return {
      root: (t = {
        display: "flex",
        alignItems: "center",
        marginBottom: "0.5em"
      }, n = e.breakpoints.up("md"), r = {
        marginBottom: e.spacing(2)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      icon: {
        marginLeft: 10,
        marginRight: 10,
        fontSize: 20
      }
    };
    var t, n, r;
  }),
      i = n(10),
      l = function l(e) {
    var t = e.element,
        n = t.config,
        a = (t.animation, n.time, n.category, n.align, o(), Object(i.a)());
    return r.createElement(r.Fragment, null, a ? r.createElement(r.Fragment, null) : r.createElement(r.Fragment, null, "Render index here.."));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      a = n(9),
      o = n(6),
      i = n(1);

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var c = Object(i.makeStyles)(function (e) {
    return {
      root: {
        width: "100vw",
        height: "100vh",
        backgroundColor: "red",
        display: "flex",
        flexDirection: "column"
      },
      header: l({
        display: "flex",
        flexDirection: "row",
        padding: "5vw",
        position: "absolute",
        width: "100vw"
      }, e.breakpoints.up("sm"), {
        padding: "3vw"
      }),
      content: l({
        display: "flex",
        flex: 1,
        padding: "5vw",
        flexDirection: "column",
        alignItems: "flex-start",
        marginTop: "12vh"
      }, e.breakpoints.up("md"), {
        padding: "3vw",
        flexDirection: "column",
        justifyContent: "center"
      }),
      footer: l({
        display: "flex",
        padding: "5vw",
        minHheight: 200
      }, e.breakpoints.up("sm"), {
        padding: "3vw"
      }),
      logoPrimary: {
        marginRight: "auto",
        maxWidth: 200
      },
      logoSecondary: {
        marginLeft: "auto",
        maxWidth: "calc(100px + 5vw)"
      },
      featuredImage: l({}, e.breakpoints.up("md"), {
        margin: 0,
        "& img": {
          width: "calc(100vw - 300px)",
          maxWidth: "900px",
          maxHeight: "calc(100vh - 400px)",
          objectFit: "contain",
          objectPosition: "left"
        }
      }),
      buttonStart: {
        borderRadius: "35px",
        fontSize: 30,
        padding: "5px 48px"
      }
    };
  });

  function s(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? s(Object(n), !0).forEach(function (t) {
        d(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function d(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.template,
        n = c(),
        i = t.config,
        l = i.styles,
        s = i.images || {},
        d = i.buttons || {};
    return r.createElement("div", {
      className: n.root,
      style: l.root
    }, r.createElement("div", {
      className: n.header
    }, s.logoPrimary && r.createElement("div", {
      className: n.logoPrimary,
      style: l.logoPrimary
    }, r.createElement(o.a, {
      element: Object(a.a)(u({
        component: "Image"
      }, s.logoPrimary))
    })), s.logoSecondary && r.createElement("div", {
      className: n.logoSecondary,
      style: l.logoSecondary
    }, r.createElement(o.a, {
      element: Object(a.a)(u({
        component: "Image"
      }, s.logoSecondary))
    }))), r.createElement("div", {
      className: n.content
    }, s.featured && r.createElement("div", {
      className: n.featuredImage
    }, r.createElement(o.a, {
      element: Object(a.a)(u({
        component: "Image"
      }, s.featured))
    })), r.createElement("div", null, r.createElement(o.a, {
      element: Object(a.a)(u({
        component: "Button"
      }, d.start))
    }))), r.createElement("div", {
      className: n.footer
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(1),
      a = Object(r.makeStyles)(function (e) {
    return {
      root: {
        margin: 0,
        display: "flex",
        flexDirection: "column",
        paddingBottom: e.spacing(2)
      },
      imgHover: {
        transition: e.transitions.create(["transform", "background"], {
          duration: "0.3s"
        }),
        "&:hover img": {
          transform: "translateY(-15px)"
        }
      },
      image: {
        width: "100%",
        flexShrink: 0,
        flexGrow: 0,
        overflow: "hidden",
        msInterpolationMode: "bicubic",
        transition: e.transitions.create(["transform", "background"], {
          duration: "0.3s"
        })
      },
      caption: {
        display: "block",
        marginLeft: e.spacing(2),
        lineHeight: "2em",
        position: "relative",
        color: "inherit",
        marginTop: -5,
        "&::before": {
          content: "''",
          left: -10,
          top: "-36px",
          zIndex: 2,
          width: 1,
          height: 54,
          backgroundColor: "currentColor",
          position: "absolute"
        }
      }
    };
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(1);
  var a = Object(r.makeStyles)(function (e) {
    return {
      root: {
        margin: "10px auto 20px auto",
        width: "100%"
      },
      overlay: {
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      blurb: {
        display: "inline-block",
        padding: "25px 0 0 15px",
        borderLeft: "1px solid",
        position: "absolute",
        left: "10%",
        top: "100%",
        transform: "translate(0, -20px)",
        textTransform: "none",
        fontFamily: "Montserrat",
        textAlign: "left",
        zIndex: 0
      },
      media: {
        border: "none",
        maxWidth: "100%"
      },
      videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%",
        marginBottom: 15,
        height: 0,
        width: "100%",
        zIndex: 1
      },
      video: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#000"
      },
      inner: (t = {
        position: "relative"
      }, n = e.breakpoints.down("md"), r = {
        margin: "0 auto",
        display: "flex"
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t)
    };
    var t, n, r;
  });
}, function (e, t) {
  e.exports = require("@fortawesome/free-regular-svg-icons");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(1);
  var a = Object(r.makeStyles)(function (e) {
    return {
      root: (t = {
        display: "flex",
        alignItems: "center",
        marginBottom: "0.5em"
      }, n = e.breakpoints.up("md"), r = {
        marginBottom: e.spacing(2)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      icon: {
        marginLeft: 10,
        marginRight: 10,
        fontSize: 20
      }
    };
    var t, n, r;
  });
}, function (e, t) {
  e.exports = require("@material-ui/icons");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });

  var r = n(0),
      a = n(1),
      o = n(8),
      i = n(35),
      l = function l(e) {
    var t = e.url,
        n = e.target,
        l = e.styles,
        c = e.mobilesrc,
        s = e.shadow,
        u = e.src,
        d = e.caption,
        m = Object(i.a)();
    return r.createElement(r.Fragment, null, t ? r.createElement("figure", {
      className: m.root,
      style: l || {}
    }, t.includes("https://") || t.includes("https://") || t.includes("mailto:") ? r.createElement("a", {
      href: t,
      target: n ? "_blank" : ""
    }, r.createElement("picture", null, c && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: c
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: u,
      className: m.image,
      style: {
        boxShadow: s ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      }
    }))) : r.createElement(o.NavLink, {
      to: t,
      className: m.imgHover
    }, r.createElement("picture", null, c && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: c
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: u,
      className: m.image,
      style: {
        boxShadow: s ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      }
    }))), d && r.createElement(a.Typography, {
      variant: "caption",
      className: m.caption
    }, d)) : r.createElement("figure", {
      className: m.root,
      style: l || {}
    }, r.createElement("picture", null, c && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: c
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: u,
      style: {
        boxShadow: s ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      },
      className: m.image
    })), d && r.createElement(a.Typography, {
      variant: "caption",
      className: m.caption
    }, d)));
  },
      c = {
    capaciteit: function capaciteit() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "45px",
          margin: "0px 0 20px 0"
        }
      }, "1. Creëren van (extra) tijdelijke verblijfscapaciteit in de regio"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Door een combinatie van interne renovatie en uitbouw bij Gereia (Zorggroep Sint Maarten) ontstaat uitbreiding van de bestaande Geriatrische Revalidatiezorg / Eerstelijnsverbijfcapaciteit van 32 naar 35 plaatsen. Deze extra capaciteit is hoofdzakelijk bedoeld voor thuiswonende ouderen (70+) die tijdelijk complexe zorg en / of ondersteuning nodig hebben. Door de onderlinge sterke samenwerking tussen de VVT-instellingen en de gemeenten kan het doorstroomproces binnen tijdelijk verblijf versneld worden, waardoor er extra capaciteitsruimte ontstaat binnen de regio Noordoost Twente."));
    },
    gec: function gec() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "45px",
          margin: "0px 0 20px 0"
        }
      }, "2. Geriatrisch Expertisecentrum (GEC)"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het GEC heeft als functie de kwetsbaar oudere cliënt zo goed en zo snel mogelijk op een complex gezondheidsvraagstuk te adviseren, een behandelplan te starten of te onderzoeken hoe een behandeling succesvol aangepast kan worden. Dit gebeurt vanuit een multidisciplinair team dat bestaat uit verschillende professionals, van Wmo-consulent tot specialist ouderengeneeskunde en van casemanager dementie tot revalidatiearts."));
    },
    innovatieGarage: function innovatieGarage() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "45px",
          margin: "0px 0 20px 0"
        }
      }, "3. Innovatiegarage"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het doel van de Innovatiegarage is dat ketenpartners met elkaar de zorgketenprocessen rondom de thuiswonende oudere beter en slimmer organiseren. In het eerste jaar richt de Innovatiegarage zich op:"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("li", null, "Het zichtbaar en breed toegankelijk maken van het preventieve educatieaanbod voor ouderen en hun mantelzorgers om meer eigen regie te pakken en vitaal ouder te worden in Noordoost Twente.", " "), r.createElement("li", null, "Onderlinge verbinding maken tussen de ketenpartners, zodat men elkaar daadwerkelijk kan versterken."), r.createElement("li", null, "Gaandeweg ontdekken welke educatieaanbod nog mist en dit alsnog ontwikkelen.")), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In dit plan zullen noodzakelijke ruimten voor behandeldiensten, therapiefaciliteiten en een aantal kantoorruimten en thuiszorgfuncties van Gereia fysiek verplaatst worden naar MST Oldenzaal. Tevens worden daar zowel de functie van het Geriatrisch Expertisecentrum als de Innovatiegarage uitgerold. Beide complexen (Gereia en MST) zijn verbonden door middel van een verbindingstunnel die ook voor minder validen toegankelijk is. Op deze manier kan een clustering van de drie pijlers worden gerealiseerd in twee goed geoutilleerde en met elkaar verbonden complexen op een markante en goed bereikbare locatie in de stad Oldenzaal."));
    },
    digitalisering: function digitalisering() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        gutterBottom: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Nieuwe telefoonfunctionaliteiten"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Naast de vernieuwingen van HiX zijn ook nieuwe telefoonfunctionaliteiten (denk aan de portalen en HiX verpleegkundigen mobieltjes) uitgerold met HiX, waardoor de netwerken verder geoptimaliseerd zijn. Dit proces loopt door in 2022."), r.createElement(a.Typography, {
        variant: "h4",
        gutterBottom: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Connected care en E-health"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In de digitalisering zullen met de komst van HiX nieuwe mogelijkheden worden vormgegeven aan beeldbellen. Dit is noodzakelijk om de patiënt ook op afstand beter te kunnen bedienen."), r.createElement(a.Typography, {
        variant: "h4",
        gutterBottom: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Vernieuwing ICT datacenter"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In 2021 is veel tijd besteed aan de vernieuwing van het ICT Datacenter. In 2022 wordt dit grootschalige traject afgerond. Daarmee is het kloppend hart van onze ICT vernieuwd en verplaatst vanuit de oudbouw naar de nieuwbouw van MST."), r.createElement(a.Typography, {
        variant: "h4",
        gutterBottom: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Regionaal informatie platform"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In 2021 is in de regio een aantal grote initiatieven gestart om er voor te zorgen dat MST in 2022 kan voldoen aan de wetgeving om patiëntinformatie optimaal te kunnen delen met andere zorginstellingen. We werken aan een regionaal Informatie platform dat er voor moet zorgen dat MST kan voldoen aan de wetgeving rondom E-inzicht. Zorg Net Oost (ZNO) coördineert de regionale samenwerking tussen ziekenhuizen, VVT instellingen, laboratoria, huisartsen en kleinere zorginstellingen."));
    },
    reuma: function reuma() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontFamily: "Poppins",
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "30px",
          margin: "0px 0 20px 0"
        }
      }, "Inzicht in uitkomstinformatie leidt tot meer gepersonaliseerde zorg voor reumapatiënten, thuis en in het ziekenhuis"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "1 op de 9 mensen in Nederland heeft een vorm van reuma. Deze chronische ziekte heeft een grote impact op het leven van patiënten. De Santeon ziekenhuizen, het Maasstad Ziekenhuis, het Medisch Spectrum Twente en het St. Antonius Ziekenhuis, werken via het Samen Beter programma aan het verbeteren van de zorg voor reumapatiënten. Door het Samen Beter programma hebben we voor het eerst op deze schaal inzicht gekregen in de data voor uitkomsten, medicatie en zorgprocessen van onze eigen patiënten. Hierdoor kunnen resultaten tussen ziekenhuizen effectief met elkaar vergelijken en praktijkvariatie zichtbaar maken. De resultaten van het Santeon verbeterprogramma zijn gebundeld in de publicatie Samen Beter Inflammatoire Artritis. De voorzitter van de Nederlandse Vereniging voor Reumatologie en de voorzitter van de Patiëntfederatie Nederland namen de resultaten op Wereld Reuma Dag (12 oktober 2021), in ontvangst."), r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Voorspelmodel voor het gepersonaliseerd afbouwen van reumamedicatie"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Binnen het Santeon Samen Beter programma, dat is gebaseerd op de Value-Based Health Care methode, staat het meten, analyseren en verbeteren van uitkomsten centraal. Hieruit blijkt dat er verschillend wordt omgegaan met het (digitaal) monitoren van de ziekte, maar ook met het op- en afbouwen van reumamedicatie bij chronische patiënten. Zij gebruiken vaak langdurig een combinatie van medicijnen die veel bijwerkingen kunnen geven en bovendien erg kostbaar zijn voor de maatschappij. Het afbouwen van medicatie is echter complex, en hangt af van veel factoren, die per patiënt kunnen variëren. Daarom werken de Santeon ziekenhuizen aan een voorspelmodel voor het gepersonaliseerd afbouwen van deze medicatie. Uniek aan het model is dat deze is gebaseerd op real-life uitkomsten van bijna 12% van de Nederlandse reumapatiënten."), r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#3DBCBD",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Ziekenhuis PROMs-dashboards voor gepersonaliseerde reumazorg"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Door de chronische aard van de ziekte reuma is het belangrijk dat zorgprofessionals en patiënten goed zicht hebben op het ziektebeloop. Om dit inzicht (bekeken vanuit het perspectief van de patiënt) te vergroten, zetten de ziekenhuizen actief in op het uitvragen van onderwerpen die voor patiënten het belangrijkst zijn via vragenlijsten (PROMs, Patient Reported Outcome Measures). Ook sturen zij steeds meer op het optimaal benutten ervan in de spreek-en huiskamer. Zo werken de Santeon ziekenhuizen met PROMs-dashboards, waarin de uitkomsten van de vragenlijst en visueel zijn weergegeven. De dashboards gevende patiënt en zorgverlener in één oogopslag inzicht in de actuele situatie, opvallende uitkomsten en historische patronen. Hierdoor zijn de ziekenhuizen in staat om steeds meer gepersonaliseerde zorg te leveren. Ook geeft het patiënten handvatten om mee te beslissen over hun eigen zorgtraject."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "“Voor reumapatiënten is het belangrijk om controle te krijgen over hun ziekte. Via het online patiënten portaal kunnen patiënten het beloop van hun ziekte volgen in relatie tot de uitkomsten van de vragenlijsten. Dat geeft hen heldere inzichten, wat ten goede komt aan het gesprek in de spreekkamer en het onder controle krijgen van de ziekte.” Marjan Ghiti, medisch leider en reumatoloog in het Medisch Spectrum Twente"), r.createElement("iframe", {
        src: "https://www.youtube.com/embed/WjLfch-2R80",
        width: "650px",
        frameBorder: "0",
        height: "360px",
        style: {
          maxWidth: "100%",
          marginBottom: "40px"
        }
      }), r.createElement(a.Button, {
        variant: "contained",
        style: {
          color: "#fff",
          backgroundColor: "#3DBCBD"
        },
        href: "https://santeon.nl/aandoening/reuma/",
        target: "_blank"
      }, "Samen Beter publicatie reuma"));
    },
    borstkanker: function borstkanker() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Ontwikkelingen borstkanker"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het afgelopen jaar zijn er ontwikkelingen geweest wat betreft borstkanker: implementatie van de keuzehulp, training samen beslissen voor betrokken chirurgen en verpleegkundig specialisten, en de online publicatie van de patiëntgerichte infographic. Daarnaast zijn tools in ontwikkeling als dashboard patient like me (zodat de patiënt zelf keuzes kan maken rondom de behandeling) en informatietools anti hormonale therapie en palbociclip (informatie op een voor patiënten begrijpelijke manier aanbieden zodat zij goed gefundeerde keuzes kunnen maken)."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Borstkankerpatiënten komen tijdens hun zorgproces op verschillende momenten voor belangrijke keuzes te staan. Op deze momenten kunnen zij samen met hun zorgverlener beslissen welke zorg het beste aansluit bij hun specifieke situatie en behoeften. Voor deze sleutelmomenten in het zorgproces worden in het Experiment keuze-ondersteunende middelen ontwikkeld."), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/08-HOOFDSTUK PATIËNTEN/Ontwikkelingen borstkanker-Group 2361.jpg",
        target: "",
        styles: {}
      }), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Behandelingen"), r.createElement("br", null), "Nadat de diagnose borstkanker is gesteld volgt doorgaans zo snel mogelijk een behandeling. In onderstaande infographic laten we de resultaten zien van de behandelingen die in de Santeon ziekenhuizen worden uitgevoerd. Welke behandeling u krijgt en het beste bij u past, wordt bepaald samen met de zorgverlener."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Kwaliteit van leven"), r.createElement("br", null), "Voor de vragen die vallen onder kwaliteit van leven liggen de scores tussen 0 en 100. Hoe hoger de score, hoe hoger de kwaliteit van leven op dit onderdeel wordt ervaren. De scores zoals worden vermeld, betreffen de gemiddelde scores van ruim 400 borstkankerpatiënten onder behandeling in OLVG, Maasstad ziekenhuis, Martini ziekenhuis en Catharina ziekenhuis een jaar na de start van de behandeling. Voor meer informatie over kwaliteit van leven in het algemeen, kunt terecht op de website van de Borstkanker Vereniging (https://www.borstkanker.nl/)."), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/08-HOOFDSTUK PATIËNTEN/Ontwikkelingen borstkanker-Group 2362.jpg",
        target: "",
        styles: {}
      }), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/08-HOOFDSTUK PATIËNTEN/Ontwikkelingen borstkanker-Group 2363.jpg",
        target: "",
        styles: {
          width: "345px"
        }
      }));
    },
    ervaringsmeting: function ervaringsmeting() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Patiënt ErvaringsMeting (1 x per jaar): cijfer MST breed: 8,4"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Jaarlijks onderzoekt MST via een Patiënt ErvaringsMeting de patiënttevredenheid. Patiënten beoordelen MST in 2021 gemiddeld met een 8,4 (bron: Patiënt ErvaringsMeting 2021). Zowel de kliniek (cijfer: 8,5) als polikliniek (cijfer: 8,4) worden goed beoordeeld. Ruim 97% van de respondenten geeft MST een voldoende. Punten die bijzonder gewaardeerd door respondenten zijn onder andere de professionele, deskundige medewerkers en de persoonlijke benadering. Patiënten voelen zich veilig in MST."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Aandachtspunten die patiënten het ziekenhuis meegeven zijn:"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Vriendelijkere bejegening tijdens het verblijf in ziekenhuis:", " "), r.createElement("br", null), "ontvangst op de poli en het tijdig aankondigen van langer wachten in poliruimte"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Betere inhoudelijke communicatie:"), r.createElement("br", null), "managen van verwachtingen rondom afspraken, vervolgzorg, nieuwe behandelaren"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Efficiency:"), r.createElement("br", null), "werken aan toegangstijden tot polikliniek en wachttijden tot diagnostiek en behandeling"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In 2022 staat er een nieuwe Patiënt ErvaringsMeting op het programma. Dit jaar kunnen meer afdelingen meedoen aan de meting, waardoor meer specialismen de kans krijgen om ook echt met de patiëntenfeedback aan de slag te gaan. Daarnaast werkt MST binnen Santeon samen met andere ziekenhuizen, om zo ontwikkelingen op het gebied van patiëntervaringen nauwgezet te kunnen volgen."));
    },
    patientenervaringen: function patientenervaringen() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Continu meten van patiëntervaringen"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "MST meet continu patiëntervaringen, met behulp van iPads. Met de antwoorden op een aantal vragen verzamelen afdelingen feedback van de geleverde zorg en krijgen we een beter beeld hoe de patiënt het bezoek aan MST heeft ervaren. Dit biedt ons de gelegenheid om de zorg iedere dag te verbeteren. Continu meten van patiëntenervaringen is onderdeel van het dagelijkse werkproces geworden. Op de poliklinieken hebben inmiddels bijna alle afdelingen een zuil met iPad, in 2022 volgt volledige uitrol op de resterende poliklinieken. Ook verkennen we in 2022 de mogelijkheden om afdelingsspecifieke vragen toe te voegen aan de zuilen, zodat er gerichter feedback kan worden gegeven."));
    },
    samenbeslissen: function samenbeslissen() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Samen beslissen: zorgtrajecten inrichten conform de kaders van ‘Samen beslissen’"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Om ’Samen beslissen’ te ontwikkelen, is het belangrijk dat patiënten en artsen hierbij eenzelfde beeld hebben. Daarvoor heeft een onderzoek plaatsgevonden, met een respons van 1000 patiënten en ruim 100 artsen. Op basis hiervan zijn samen met het Medisch Stafbestuur en de medisch managers de definitie en kaders van ‘Samen beslissen’ vastgesteld. Het hoge percentage laaggeletterdheid (24% in de gemeente Enschede) maakt de communicatie tussen arts en patiënt soms lastig. ‘Samen beslissen’ start met elkaar begrijpen. Daarom is op 15 december het webinar ‘Samen beslissen bij laaggeletterdheid’ georganiseerd, in samenwerking met de Stichting Lezen en Schrijven."), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/08-HOOFDSTUK PATIËNTEN/Patienten – 22 - DESKTOP.svg",
        target: "",
        styles: {}
      }));
    },
    epd: function epd() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "EPD met patiëntenportaal: mogelijkheden, risico’s en kansen benoemen"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het EPD, en met name het patiëntenportaal, biedt ons de mogelijkheden de volgende stap te zetten in patiëntenparticipatie. We krijgen een holistischer beeld van de patiënt, vooral nu alle afdelingen met hetzelfde dossier werken. Informatie die elders is uitgevraagd, hoeft niet opnieuw te worden verzameld. Het dossier en het portaal bieden ruimte om de patiënt te bevragen over zijn thuissituatie, wensen en behoeften, waardoor de gezamenlijke besluitvorming kan worden verbeterd."));
    },
    gastvrijheid: function gastvrijheid() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Gastvrijheidstraject"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Een aantal teams heeft de eerste stap van het gastvrijheidstraject doorlopen door een gastvrijheidsscan uit te voeren. Deze scan gaat over het beeld dat de deelnemers hebben over de organisatie (cultuur en strategie), de eigen afdeling (motivatie, communicatie en samenwerking) en de randvoorwaarden (systemen en processen) in relatie tot gastvrijheid en patiëntgerichte zorg. Daarnaast zorgt de scan voor het creëren van commitment om aan de slag te gaan met verbeteren vanaf de werkvloer."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Na de scan doorlopen teams nog twee workshops, waarin doelen worden gesteld, verbeterpunten in kaart worden gebracht en de eerste stappen gezet worden om de gastvrijheid, patiëntgerichtheid en samenwerking te verbeteren. Tegelijkertijd leren de deelnemers om elkaar positieve en krachtige feedback te geven én ze leren elkaar te coachen in de ontwikkeling van hun gastvrijheidsbewustzijn."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Met het gastvrijheidstraject geven we invulling aan de strategische agenda van MST waarbij gastvrijheid één van de speerpunten is."));
    },
    vim: function vim() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "VIM meldingen vanuit extern worden binnen 56 dagen afgehandeld in samenwerking met externe partij"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In MST maken we het externe organisaties mogelijk om incidenten te melden. Zodoende kunnen we blijven verbeteren. In het jaarplan 2021 hebben we gezegd dat externe incidentmeldingen binnen 56 mediane doorlooptijd afgehandeld moeten zijn. We kennen een gemiddelde van 40 dagen, dus dit zit binnen de gestelde norm. Zodoende optimaliseren we de zorg in de keten."));
    },
    gekwalificeerd: function gekwalificeerd() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Voldoende gekwalificeerde medewerkers"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De afspraken die in 2021 landelijk door de ziekenhuizen zijn gemaakt en vastgelegd in de Verklaring Arbeidsmarkt Zorg (VAZ), worden door MST regionaal opgepakt in FZO verband (Fonds Ziekenhuis Opleidingen) en in de samenwerking van de regionale ziekenhuizen met Saxion en ROC van Twente. Aan Saxion is de opdracht verstrekt om samen met de opleidingsadviseurs uit de ziekenhuizen de mogelijkheden te verkennen voor innovatie (meer en anders opleiden), zodat de grote behoefte aan stages kan worden gerealiseerd. De bestuurders van de FZO regio waar MST onderdeel van uitmaakt, hebben met elkaar het commitment herbevestigd om gezamenlijk te sturen op het opleiden van voldoende medewerkers voor de FZO beroepen. Zij wensen hierin een verbeterslag te maken door op bestuurlijk niveau te monitoren en elkaar aan te spreken. Om deze doelstelling te kunnen bereiken, is in januari 2022 besloten om voor de regio voor twee jaar een gezamenlijke programmamanager aan te stellen, die kansen en mogelijkheden samen met de ziekenhuizen vertaalt in een plan van aanpak, afspraken en resultaten op het gebied van FZO doelen en innovatie (meer en anders opleiden)."));
    },
    czo: function czo() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Vanuit het project CZO Flex-level wordt gewerkt aan duurzame verbetering van het opleidingsaanbod."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "CZO Flexlevel biedt een modulair en flexibel opleidingsstelsel waardoor CZO-erkende opleidingen/leerroutes beter aansluiten op de behoeften in de zorg en arbeidsmark om meer medewerkers op te leiden en hiermee een goede in- en doorstroom van zorgverleners mogelijk te maken en medewerkers voor de zorg te behouden."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In november 2021 is het projectplan CZO Flex Level in MST goedgekeurd door de RvB en is een start gemaakt met het (her)ontwikkelen van de (praktijk)leerplannen. De planning en realisatie van EPA gericht opleiden verschilt per cluster. Voor het cluster Moeder & Kind en Langdurige Zorg opleidingen hebben de uitkomsten van de consultatie over de EPA’s geleid tot een omvangrijke aanpassing van de EPA’s. Dit traject is eind 2021 afgerond met gevalideerde EPA’s. Het cluster Medische Opleidingen maakt vanaf eind 2021 officieel deel uit van het programma CZO Flex Level. Hierdoor is de doorlooptijd van CZO Flex Level voor dit cluster verlengd tot mei 2025. Daarnaast zijn in 2021 alle onderwijsinstellingen betrokken bij de opdracht om te komen tot ‘landelijk gedragen’ theorie, horend bij het EPA gericht opleiden."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De Tweede fase van CZO Flexlevel, de voorbereiding en implementatie van de Entrustable Professional Activities (EPA’s) is in 2021 in MST gestart. EPA’s geven concrete invulling aan competentie gericht opleiden op de werkplek. Essentieel in dit concept is de gedachte dat een begeleider een student pas professionele activiteiten toevertrouwt om zelfstandig uit te voeren, op het moment dat de student heeft laten zien daarin voldoende competent te zijn. De projectleiding voor de implementatie van de EPA’s in MST wordt uitgevoerd door MedST. De implementatie omvat:", r.createElement("li", null, "Het (her)ontwikkelen, introduceren en doorvoeren van flexibele en vernieuwende opleidingen en leerroutes waarbij opleidingen en leerroutes gebaseerd zijn op EPA’s"), r.createElement("li", null, "Het introduceren en doorvoeren van een nieuwe methodiek van begeleiden en bekwaam verklaren met EPA’s van studenten in de praktijk.")));
    },
    acutezorg: function acutezorg() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Flexibiliteit en versterking acute zorgvaardigheden verpleegkundigen"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Tijdens de COVID periode is taakdifferentiatie ingezet als middel om de capaciteit op de Acute afdelingen en de COVID verpleegafdelingen te verhogen. Zo was het mogelijk om medewerkers van afdelingen die werden afgeschaald, waaronder verpleegkundigen, in te zetten in de COVID Zorg. Dit heeft geleid tot het inzicht dat flexibiliteit ingebouwd kan worden in de organisatie en competenties rondom de acute patiënt kunnen worden versterkt. De ervaring die we hiermee hebben opgedaan, geeft een andere kijk op het thema functiedifferentiatie."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In het kader van het invoeringsplan nieuwe EPA structuur in de CZO opleidingen (CZO Flexlevel) is in 2021 een plan uitgewerkt voor het opleiden en inzetten van BAZ Verpleegkundigen. Deze Verpleegkundigen hebben de (CZO geaccrediteerde) opleiding Basis Acute Zorg afgerond en kunnen flexibel toegevoegd worden aan het team van IC, CCU, SEH, Recovery en AOA verpleegkundigen. Het BAZ diploma biedt ook de mogelijkheid tot verkorting van alle opleidingen op de Acute afdelingen. Dit kan een positieve bijdrage leveren aan het regionale capaciteitsvraagstuk. Bijkomend voordeel is dat deze BAZ Verpleegkundigen ook ingezet kunnen worden om de kennis rondom de vitaal bedreigde patiënt van Verpleegkundigen op verpleegafdelingen te versterken, te ontwikkelen en te borgen."), r.createElement(a.Grid, {
        container: !0,
        spacing: 6
      }, r.createElement(a.Grid, {
        item: !0,
        md: 6
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/09-HOOFDSTUK MEDEWERKERS/Medewerkers-9-inzet.jpg",
        target: "",
        styles: {}
      })), r.createElement(a.Grid, {
        item: !0,
        md: 6
      }, r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Hiermee creëren we een flexibele schil en versterken we de complexe zorg competenties. In 2021 zijn 30 MST Verpleegkundigen gestart met de complete BAZ opleiding bij CIVO Zorgopleiders. Voor deze Verpleegkundigen is het mogelijk om na deze opleiding in 2022 de IC, CCU, SEH, of Recovery opleiding te volgen, waarbij zij vrijgesteld worden van de EPA’s die al behaald zijn met het BAZ diploma."))));
    },
    initiatieven: function initiatieven() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Zilveren Kruis en Santeon werken samen aan nieuwe initiatieven ter verbetering van de zorg"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Zilveren Kruis en Santeon gaan intensief samenwerken. De samenwerking is gericht op het verbeteren van de Nederlandse (ziekenhuis)zorg, waarbij de zorg doelmatiger en efficiënter wordt geleverd, de zorg waar mogelijk dichterbij de patiënt wordt georganiseerd, de patiënttevredenheid toeneemt en waarbij de zorgkosten gelijk blijven of zelfs dalen. Het digitaliseren van zorg (informatie en communicatie) vormt hierbij een belangrijk element."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat",
          color: "#3DBCBD",
          fontWeight: 800
        }
      }, "Santeon is een uniek landelijk samenwerkingsverband waarin zeven topklinische ziekenhuizen (waaronder MST) open samenwerken met als doel de medische zorg te verbeteren door continue vernieuwing. Wat de samenwerking uniek maakt, is dat de professionals bij elkaar in de keuken kijken. Met Value-Based Health Care als leidend principe worden de beste resultaten overgenomen en als standaard geïmplementeerd om de waarde van zorg voor patiënten te vergroten."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Drie nieuwe zorginitiatieven"), r.createElement("br", null), "Binnen de samenwerking worden in eerste instantie drie nieuwe zorginitiatieven ontwikkeld, getoetst en/of opgeschaald binnen de Santeon organisatie."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In dit kader willen Zilveren Kruis en Santeon bijvoorbeeld gezamenlijk de (meer)waarde onderzoeken naar het belang – voor patiënten en artsen – van een universeel digitaal dataplatform voor IBD zorg. Hierin kan de patiënt in de thuissituatie zijn meet- en welbevindingsgegevens invoeren via de beschikbare digitale apps, onafhankelijk van welke leverancier deze komen. Een universeel dataplatform kan een stap zijn naar schaalvergroting, lagere beheerskosten en nog snellere en betere bereikbaarheid van de dienstverlening."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het tweede initiatief betreft het meetbaar maken van de effectiviteit van dure geneesmiddelen bij longkanker. Patiënten starten meestal met een combinatie van een chemo- en een immunotherapie. Niet alle patiënten houden deze combinatie tot het einde vol en gaan verder met een monotherapie. Over de effectiviteit hiervan is nog weinig bekend, ook is er geen model voorhanden dat voorspelt welke patiënten dreigen uit te vallen. Binnen de samenwerking wordt gewerkt aan zo’n predictiemodel en worden de zorguitkomsten van de gecombineerde en monotherapie gemeten."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Het derde initiatief moet bijdragen aan de juiste zorg op de juiste plek voor CVA patiënten. Hiervoor is een goede afstemming tussen het ziekenhuis en zorgpartners voor de nazorg (revalidatiecentra en/of verpleeg- en verzorgingshuizen) van belang. Met de introductie van een zorgbundel in dit project als bekostigingssystematiek worden de financieringsschotten weggenomen en samenwerking verder verbeterd."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Doel van de samenwerking is om het aantal initiatieven in de toekomst uit te breiden."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Gezamenlijke ambitie"), r.createElement("br", null), "De samenwerking tussen Santeon en Zilveren Kruis komt voort uit de gezamenlijke intentie om nieuwe zorginitiatieven op te starten, waaronder het versnellen van digitalisering in de zorg. De Santeon ziekenhuizen zijn al actief op het gebied van e-health en connected care. Zo hebben zij bijvoorbeeld eerste ervaringen opgedaan met verschillende digitale coaches en monitoringsoplossingen (IBD-coach, IBD-dream en Dear Health)."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Zilveren Kruis investeert al enkele jaren actief in zorg waarbij haar verzekerden vaker zorg in de eigen omgeving kunnen krijgen en de inzet van technologie naadloos in het zorgproces wordt ingebed. De bestaande samenwerking binnen het Santeon netwerk waarbij de uitwisseling van kennis en ervaring laagdrempelig plaats vindt, maken de hoognodige opschaling van initiatieven mogelijk."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Waardegedreven zorg blijft het uitgangspunt. Verdergaande digitalisering van zorg moet plaatsvinden op grond van zorginhoudelijke argumenten en patiëntbehoeften en niet enkel op bedrijfseconomisch argumenten."));
    },
    keuzehulp: function keuzehulp() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "De CVA keuzehulp: eerste klinisch toepasbare keuzehulp in Nederland"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat",
          color: "#3DBCBD",
          fontWeight: 800
        }
      }, "Keuzehulpen worden sinds enkele jaren in de zorg gebruikt om mensen samen met hun zorgverlener te laten beslissen bij de keuze voor een behandeling of een zorgaanbieder. De CVA keuzehulp is speciaal ontwikkeld voor patiënten die met een beroerte zijn opgenomen in het ziekenhuis. De keuzehulp ondersteunt hen bij de keuze voor een verblijfplaats na opname (de ontslagbestemming). De CVA keuzehulp is daarmee de eerste keuzehulp in Nederland die toegepast kan worden in de kliniek. De eerste ervaringen van patiënten en zorgverleners zijn positief."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "CVA staat voor cerebrovasculair accident. De CVA keuzehulp is ontwikkeld omdat patiënten met een herseninfarct en hersenbloeding behoefte hebben aan duidelijke informatie over wat hen is overkomen en wat en welke vervolgbehandelingen zij kunnen verwachten op de verschillende ontslagbestemmingen, zoals thuis, op een revalidatieafdeling van het verpleeghuis of in het revalidatiecentrum. In de keuzehulp krijgen patiënten op basis van de ernst van hun CVA en hun leeftijd inzicht in de ontslagbestemming van andere, vergelijkbare patiënten. De keuzehulp is ontwikkeld in samenwerking met patiënten en patiëntenvereniging Hersenletsel.nl. Ook is de keuzehulp uitgebreid getest onder patiënten."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Wensen en prioriteiten van patiënt voorop"), r.createElement("br", null), "De meeste Santeon ziekenhuizen hebben de CVA keuzehulp al in gebruik. Inmiddels is de keuzehulp al 350 keer uitgereikt aan patiënten. CVA-patiënt Marc Heesterbeek is enthousiast over de keuzehulp: “Als patiënt voel ik me nu meer gehoord en ben ik gemotiveerder omdat mijn prioriteiten voorop staan in mijn herstel.” In dit filmpje vertelt Heesterbeek over zijn ervaringen met de CVA keuzehulp."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Ook de eerste ervaringen van verpleegkundigen, paramedici en artsen zijn positief. Prof. dr. Renske van den Berg-Vos, neuroloog in OLVG: “Het gebruik van de CVA keuzehulp hebben we gedaan met het hele multidisciplinaire team. Alle zorgverleners rondom de CVA-patiënt zijn betrokken en gemotiveerd om deze verandering door te voeren. Samen met de patiënt verbeteren we op deze manier de zorg.” Verpleegkundig specialist Wilma Pellikaan, werkzaam in het St. Antonius ziekenhuis in Nieuwegein: “Ondanks de acute en stressvolle situatie van een opname zorgt de CVA keuzehulp ervoor dat de wensen van de patiënt gezien en gehoord worden. Het gebruik van de keuzehulp zorgt voor een andere manier van werken, waarbij de patiënt en het team samen zoeken naar de beste optie in de ontslagbestemming.”"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De ontwikkeling van de CVA keuzehulp is onderdeel van het Experiment Uitkomstindicatoren van Santeon, waarmee uitkomstinformatie toegankelijk wordt gemaakt in de spreekkamer of in de kliniek. Patiënten krijgen op maat informatie over zorguitkomsten, zodat zij – samen met hun zorgverlener – beter kunnen beslissen over welke zorg het beste bij hen past. De CVA keuzehulp is via ontwikkel- en implementatiepartner ZorgKeuzeLab beschikbaar voor alle zorgverleners en ziekenhuizen in Nederland."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Over het Experiment Uitkomstindicatoren"), r.createElement("br", null), "Binnen de Santeon ziekenhuizen wordt gewerkt aan het Experiment Uitkomstindicatoren. Doel van het Experiment is om uitkomstinformatie toegankelijk te maken in de spreekkamer. Patiënten krijgen op maat informatie over uitkomsten van zorg, zodat zij – samen met hun zorgverlener – beter kunnen beslissen over welke zorg en welk ziekenhuis het beste bij hen past. Het benutten van zorguitkomsten bij samen beslissen wordt uitgewerkt bij een drietal aandoeningen: borstkanker, CVA en chronisch nierfalen. De geleerde lessen en inzichten die worden opgedaan binnen het Experiment worden beschikbaar gesteld aan andere zorginstellingen. Het Experiment Uitkomstindicatoren maakt onderdeel uit van het programma Uitkomstgerichte Zorg van het ministerie van VWS, ZonMw begeleidt het programma. Kijk voor meer informatie op", r.createElement("a", {
        href: "https://experiment-uitkomstindicatoren.nl",
        target: "_blank"
      }, "www.experiment-uitkomstindicatoren.nl")), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Over Santeon"), r.createElement("br", null), "Santeon is een groep van zeven topklinische ziekenhuizen verspreid over Nederland die op een unieke, open manier samenwerken om de zorg aantoonbaar te verbeteren. Santeon professionals kijken bij elkaar in de keuken en nemen de beste resultaten van elkaar over. De zeven Santeon ziekenhuizen zijn: Canisius Wilhelmina Ziekenhuis in Nijmegen, Catharina Ziekenhuis in Eindhoven, Maasstad Ziekenhuis in Rotterdam, Martini Ziekenhuis in Groningen, Medisch Spectrum Twente in Enschede, OLVG in Amsterdam en het St. Antonius Ziekenhuis in Utrecht/Nieuwegein."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Bij de Santeon ziekenhuizen werken ruim 30.000 medewerkers, waarvan 2.000 specialisten en 9.500 verpleegkundigen. Een op de acht patiënten in Nederland bezoekt een Santeon ziekenhuis."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Kijk voor meer informatie en resultaten op ", r.createElement("a", {
        href: "https://santeon.nl",
        target: "_blank"
      }, "www.santeon.nl")));
    },
    raadvanbestuur: function raadvanbestuur() {
      return r.createElement("div", null, r.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, r.createElement(a.Typography, {
        variant: "h1",
        style: {
          fontWeight: 700,
          color: "#299CAD"
        },
        paragraph: !0
      }, "Raad van Bestuur")), r.createElement(a.Grid, {
        container: !0,
        spacing: 4
      }, r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 4,
        alignItems: "center",
        justify: "center",
        style: {
          display: "flex"
        }
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-foto-de Rooij.jpg",
        target: "",
        styles: {
          width: 180
        }
      })), r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 8
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-1-de Rooij.svg",
        target: "",
        styles: {}
      }))), r.createElement(a.Grid, {
        container: !0,
        spacing: 4
      }, r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 4,
        alignItems: "center",
        justify: "center",
        style: {
          display: "flex"
        }
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-foto-den Boon.jpg",
        target: "",
        styles: {
          width: 180
        }
      })), r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 8
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-2-den Boon.svg",
        target: "",
        styles: {}
      }))), r.createElement(a.Grid, {
        container: !0,
        spacing: 4
      }, r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 4,
        alignItems: "center",
        justify: "center",
        style: {
          display: "flex"
        }
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-foto-den Hollander.jpg",
        target: "",
        styles: {
          width: 180
        }
      })), r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 8
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Raad van bestuur-3-den Hollander.svg",
        target: "",
        styles: {}
      }))));
    },
    complicaties: function complicaties() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "24px",
          margin: "0px 0 20px 0"
        }
      }, "Minder complicaties"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Uit de resultaten blijkt ten eerste dat de patiënt fitter uit de operatie komt en daardoor minder lang in het ziekenhuis ligt. De mediane ligduur lag voorheen op zes nachten, dit is afgenomen naar drie nachten. De kans op ernstige complicaties is afgenomen en daarmee ook de kans dat een heroperatie noodzakelijk is."), r.createElement(a.Grid, {
        container: !0,
        spacing: 6
      }, r.createElement(a.Grid, {
        item: !0,
        md: 6
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/13-HOOFDSTUK SANTEON/Santeon – 5-grafiek 1.svg",
        target: "",
        styles: {}
      })), r.createElement(a.Grid, {
        item: !0,
        md: 6
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/13-HOOFDSTUK SANTEON/Santeon – 5-grafiek 2.svg",
        target: "",
        styles: {}
      }))), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", {
        style: {
          fontWeight: 800,
          color: "#3DBCBD"
        }
      }, "Misselijkheid neemt af"), r.createElement("br", null), "De pijnstilling die een patiënt krijgt voor de operatie, is flink veranderd. We dienen nu een combinatie van andere pijnstillers met minder bijwerkingen toe. Dat zorgt ervoor dat patiënten minder misselijk zijn en minder pijn ervaren. Ook maken we geen gebruik meer van een epiduraal katheter, maar van een eenmalige ruggenprik. Dat bevordert het snelle herstel."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", {
        style: {
          fontWeight: 800,
          color: "#3DBCBD"
        }
      }, "Meer ERAS-programma’s"), r.createElement("br", null), "Door de goede resultaten met ERAS werken inmiddels ook leverchirurgie, urologie voor het verwijderen van de nier en de grote buik operaties voor gynaecologische oncologie volgens dit programma."));
    },
    portefeuille: function portefeuille() {
      return r.createElement("div", null, r.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, r.createElement(a.Typography, {
        variant: "h1",
        style: {
          fontWeight: 700,
          color: "#299CAD"
        },
        paragraph: !0
      }, "Portefeuilleverdeling Raad van Bestuur"), r.createElement(a.Typography, {
        variant: "h3",
        style: {
          fontWeight: 500,
          color: "#EAAB00",
          fontSize: "22px",
          fontFamily: "Montserrat"
        },
        paragraph: !0
      }, "Vastgesteld door de Raad van Toezicht op 1 februari 2021")), r.createElement(a.Grid, {
        container: !0,
        spacing: 4
      }, r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 6,
        alignItems: "center",
        justify: "center",
        style: {
          display: "flex"
        }
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Portefeuilleverdeling-1.svg",
        target: "",
        styles: {
          width: 180
        }
      })), r.createElement(a.Grid, {
        item: !0,
        xs: 12,
        md: 6
      }, r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/14-HOOFDSTUK TOEZICHT, BESTUUR EN ADVIESORGANEN/Portefeuilleverdeling-2.svg",
        target: "",
        styles: {}
      }))));
    },
    toezichtsrol: function toezichtsrol() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Werkgeversrol"), r.createElement("br", null), "De Raad van Bestuur bestuurt het ziekenhuis en draagt de eindverantwoordelijkheid. Hij is verantwoordelijk voor de realisatie van de doelstellingen, de strategie, het beleid en de resultaatsontwikkeling. MST wordt bestuurd door een meerhoofdige Raad van Bestuur, waarvan één persoon de rol van voorzitter vervult."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De Raad van Toezicht benoemt en ontslaat de leden van de Raad van Bestuur. Ook evalueert de Raad van Toezicht het functioneren van de leden van de Raad van Bestuur. Daarnaast zorgt hij voor het vaststellen van een maatschappelijk passende beloning, de contractduur, de rechtspositie en de andere arbeidsvoorwaarden."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Verandering samenstelling RvT"), r.createElement("br", null), "Op 1 maart 2021 zijn toegetreden tot de Raad van Toezicht: Drs. B.J.M. (Gita) Gallé (Lid Raad van Bestuur Prinses Máxima Centrum) en Mr. B.G.M. (Barbara) Lemstra."), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/Group 2370.svg",
        target: "",
        styles: {}
      }), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Samenvatting belangrijkste besluiten RvT in 2021"), r.createElement("br", null), "De belangrijkste besluiten van de Raad van Toezicht in 2021 waren de benoeming van mevrouw Gallé en mevrouw Lemstra als leden van de Raad van Toezicht, het benoemen van de heer J. den Boon als voorzitter Raad van Bestuur, het benoemen van mevrouw J. Berger-Roelvink als lid Raad van Bestuur en het benoemen van mevrouw M. Vollenbroek-Hutten als lid Raad van Bestuur. Daarnaast is goedkeuring verleend aan de verkoop van grond te Oldenzaal en de vestiging van een hypotheekrecht ten aanzien van het parkeerterrein aan de Beltstraat te Enschede, het jaarverslag, de jaarrekening, de begroting en het jaarplan."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Lees", " ", r.createElement("a", {
        href: "https://www.mst.nl/p/jaarbericht-2021-raad-van-toezicht/",
        target: "_blank"
      }, "hier"), " ", "verder over de nevenfuncties, commissies, belangrijkste besluiten en informatievoorziening."));
    },
    activiteiten: function activiteiten() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "48px",
          margin: "0px 0 20px 0"
        }
      }, "Activiteiten in 2021"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Net 2020 heeft 2021 voor de medische staf voornamelijk in het teken gestaan van de Covid-19 pandemie. Ook in 2021 waren vakgroepen genoodzaakt om hun zorg af te schalen en/of op een andere manier te leveren, bijvoorbeeld via beeldbellen. Andere vakgroepen kregen juist te maken met een grote toestroom van het aantal Covid patiënten en kenden daardoor een lange periode van grote werkdruk. Dus ook in 2021 was de impact van de Covid pandemie voor de medische staf als geheel groot."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Daarnaast was 2021 ook voor de medische staf het jaar van de NIAZ accreditatie en de implementatie van het nieuwe EPD. Veel medisch specialisten hebben het afgelopen jaar, bijvoorbeeld in de rol van Chief Medical Information Officer, proceseigenaar medisch proces of key-user, een belangrijke bijdrage geleverd aan de succesvolle implementatie van het nieuwe elektronische patiëntendossier. Een mooi initiatief is de start van het Medisch Leiderschapsprogramma. Dit leiderschapsprogramma dat is ontwikkeld door en voor de staf is bedoeld voor medisch specialisten in MST die hun talenten in de (niet-) medische rollen verder willen ontwikkelen om bij te kunnen dragen aan duurzame en impactvolle vernieuwingen binnen MST en daarbuiten. In het voorjaar is de eerste groep medisch specialisten met het Leiderschapsprogramma van gestart."), r.createElement(l, {
        url: "",
        caption: "",
        mobilesrc: "",
        shadow: "",
        src: "https://d6j399hnl3eyg.cloudfront.net/mst2021/08-HOOFDSTUK PATIËNTEN/Ontwikkelingen borstkanker-Group 2361.jpg",
        target: "",
        styles: {}
      }), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In haar rol als duaal partner van de Raad van Bestuur heeft het Stafbestuur vorig jaar in het wekelijks Bestuurlijk Strategie Overleg mede besluiten genomen over onder andere de vorming van het nieuwe centrum Punt voor Parkinson en de herinrichting van het 1e lijns accountmanagement ter bevordering van de onderlinge samenwerking tussen medisch specialisten en huisartsen uit de regio."));
    },
    ondernemingsraad: function ondernemingsraad() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "30px",
          margin: "0px 0 20px 0"
        }
      }, "Ondernemingsraad"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "De leden van de Ondernemingsraad in 2021"), r.createElement("br", null), "Ilse Asschert, Hemodialyse verpleegkundige ", r.createElement("br", null), "Evelien Bekhuis, radiodiagnostisch laborant ", r.createElement("br", null), "Özgür Bingöl, klinisch perfusionist ", r.createElement("br", null), "Sandra Crietee-Krikke, Operatieassistent Thorax-OK (lid per 1 april 2020) ", r.createElement("br", null), "Tonnie Eertman, culinair service medewerker ", r.createElement("br", null), "Tomas Fransen, IC-verpleegkundige, (lid per 1 april 2020) ", r.createElement("br", null), "Lydia Matas Guiot, verpleegkundige Thoraxcentrum ", r.createElement("br", null), "Jolanda Nijhuis, pacu/recovery verpleegkundige ", r.createElement("br", null), "René Peeze, gipsverbandmeester en voorzitter OR ", r.createElement("br", null), "Kim Roelofs, verpleegkundige AOA ", r.createElement("br", null), "Liane Strijker, projectleider ICT ", r.createElement("br", null), "Lenneke Timmerman, opleidingsadviseur en vice voorzitter OR ", r.createElement("br", null), "Birgitte Trentmann, Operatieassistent AOK (lid per 1 april 2020)"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Belangrijkste werkzaamheden 2021"), r.createElement("br", null), "Corona had ook in 2021 nog veel invloed op onze organisatie. Hierdoor werd de OR wederom gedwongen tot thuiswerken. Daar waar nodig was zijn OR leden voor de zorg ingezet."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De gevolgen voor de bedrijfsvoering van MST door de Coronapandemie die mede gezorgd heeft voor een onverminderde hoge werkdruk en een hoog ziekteverzuim onder medewerkers. De OR heeft hier samen met de ARBO de nodige aandacht aan geschonken", " "), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "De volgende onderwerpen hadden ook de aandacht van de OR:"), r.createElement("br", null), "ARBO gerelateerde onderwerpen, zoals het COVID beleid en het thuiswerkbeleid. Daarnaast waren NIAZ, Generiek functiehuis en EPD grote vraagstukken binnen onze organisatie."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Een van de onderwerpen die de OR in 2021 heeft opgepakt is het onderwerp “Cultuur in MST”. Tijdens de scholing is er met de Raad van Bestuur, Verpleegkundige adviesraad, Human Resource Management, Medisch Stafbestuur, en enkele leden van de Leading Coalition over dit onderwerp gediscussieerd."));
    },
    adviesraad: function adviesraad() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "30px",
          margin: "0px 0 20px 0"
        }
      }, "Verpleegkundig Adviesraad"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "De leden van de Verpleegkundig Advies raad in 2021"), r.createElement("br", null), "De VAR heeft in 2021, drie leden uitgezwaaid en drie nieuwe leden ontvangen. Ook heeft er een wisseling plaatsgevonden in het Dagelijks bestuur. Elise Veenhoven heeft per 1 november het stokje als voorzitter overgenomen van Belinda van den Bovenkamp. Marloes Lammers is vice- voorzitter geworden."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Belinda van den Bovenkamp, Teamhoofd Neurologie", r.createElement("br", null), "Elise Veenhoven, Interventie verpleegkundige HCK", r.createElement("br", null), "Marloes Lammers, Verpleegkundige Vrouw- kind centrum", r.createElement("br", null), "Marieke Holtslag, Stafdienst Kwaliteit en veiligheid ", r.createElement("br", null), "Jolanda Schoemaker, verpleegkundig specialist reumatologie", r.createElement("br", null), "Ilona kienhuis, verpleegkundige oncologie E4", r.createElement("br", null), "Tessa Nijhuis, verpleegkundige chirurgie/ trauma ", r.createElement("br", null), "Sabine van ’t Bolscher, verpleegkundige Acute zorg", r.createElement("br", null), "Rick Boers, Verpleegkundige Interne geneeskunde", r.createElement("br", null), "Stefanie Kleizen, verpleegkundige kinderafdeling"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Belangrijkste werkzaamheden 2021"), r.createElement("br", null), "De coronapandemie was van grote invloed op de werkzaamheden van de VAR in 2021. De VAR nam actief deel aan het Crisis Beleids Team. Hierdoor werden we vroegtijdig betrokken bij besluiten, en werd advies gevraagd omtrent de dagelijkse praktijk met betrekking tot Covid zorg."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "De VAR is het afgelopen jaar tevens bezig geweest met onderzoeken naar de mogelijkheden om de VAR meer in positie te brengen op bestuurlijk niveau, door het professioneel verpleegkundig zeggenschap inhoud te geven, en meer verpleegkundige beleidsbeïnvloeding op bestuurlijk niveau te realiseren."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Ook werd het deskundig advies van de VAR gevraagd over de bezoekersregeling tijdens de Covid periode. Een ongevraagd advies betrof EWS inzake HIX. Ook de NIAZ accreditatie was een belangrijk aandachtspunt voor de VAR in 2021. Daarnaast neemt de VAR deel aan verscheidene werkgroepen en projecten."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Gegeven adviezen:"), r.createElement("br", null), r.createElement("li", null, "Benoeming twee nieuwe leden Raad van Toezicht"), r.createElement("li", null, "Leidinggevende structuur Vrouw Kind Centrum"), r.createElement("li", null, "Evidence Based Practice"), r.createElement("li", null, "Tensiemeters"), r.createElement("li", null, "Visiedocument Medisch Specialistisch Spoor")));
    },
    clientenraad: function clientenraad() {
      return r.createElement("div", null, r.createElement(a.Typography, {
        variant: "h4",
        paragraph: !0,
        style: {
          fontWeight: 800,
          color: "#EAAB00",
          fontSize: "30px",
          margin: "0px 0 20px 0"
        }
      }, "Cliëntenraad"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "De leden van de Verpleegkundig Advies raad in 2021"), r.createElement("br", null), "We hebben in 2021 drie leden uitgezwaaid en drie nieuwe leden verwelkomt. Tevens heeft Secil Arda het stokje als voorzitter overgenomen en Jan Mulder die van vice- voorzitter. Secil Arda ", r.createElement("br", null), "Jan Mulder ", r.createElement("br", null), "Marie- Louise Fisscher ", r.createElement("br", null), "Madeleine ter Laak ", r.createElement("br", null), "Pauline Nordbeck ", r.createElement("br", null), "Anne Overbeek ", r.createElement("br", null), "Jacob Pol ", r.createElement("br", null), "Henk Dijks ", r.createElement("br", null), "Savan Grolleman ", r.createElement("br", null), "Julia Keizer ", r.createElement("br", null), "Emile Muhlradt ", r.createElement("br", null), "Andre de Lizer"), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, r.createElement("strong", null, "Belangrijkste werkzaamheden 2021 "), r.createElement("br", null), "Een van de aandachtspunten van de CR was en is de Corona pandemie en de gevolgen daarvan voor de patiëntenzorg en onze medewerkers. De CR heeft zich hierover met regelmaat laten informeren en heeft meegedacht. De CR vindt ook de inhaalzorg hierin van groot belang."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Daarnaast heeft de CR adviezen gegeven onder andere over het parkeerbeleid in MST, de benoeming van de nieuwe leden Raad van Bestuur, over de samenwerking tussen ZGT en MST, Punt voor Parkinson Twente, het handen schudden en testweigeraars Covid19."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "In 2021 is de Wet medezeggenschap cliënten zorginstellingen (WMCZ), regelingen informatieprotocol met RvB, MSB’s en KON, tot stand gekomen en ondertekend."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Regelmatig heeft de Cliëntenraad gesprekken met externe organisaties, zoals de Cliëntenraad van het ZGT, de Cliëntenraad van andere Santeon ziekenhuizen, de IGJ, Raad van Toezicht, patiëntenfederatie en NVZ over PGO en psychomedisch/ MPU centrum over evaluatie rapport."), r.createElement(a.Typography, {
        variant: "body2",
        paragraph: !0,
        style: {
          fontFamily: "Montserrat"
        }
      }, "Tot slot heeft de Clientenraad deelgenomen aan het project leefstijl en vitaliteit, gesprekken gehad met Qualicor/ NIAZ, het Cliëntenpanel beheerd  en begeleid en de totstandkoming van het EPD begeleid."));
    }
  };
}, function (e, t) {
  e.exports = require("react-grid-layout");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return d;
  });
  var r = n(0),
      a = n(12),
      o = n.n(a),
      i = n(1),
      l = n(3);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var d = function d(e) {
    var t = e.element,
        n = e.onChange,
        a = Object(l.a)(t.config, function (e) {
      return n(s(s({}, t), {}, {
        config: e
      }));
    }),
        c = a("title", "List title"),
        u = a("variant", "small");
    return r.createElement(r.Fragment, null, r.createElement(i.TextField, {
      label: "Title",
      value: c.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return c.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(i.InputLabel, {
      shrink: !0,
      id: "select-variant-label"
    }, "Variant"), r.createElement(i.Select, {
      labelId: "select-variant-label",
      fullWidth: !0,
      value: u.value,
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 20
      }
    }, r.createElement(i.MenuItem, {
      value: "small"
    }, "Small"), r.createElement(i.MenuItem, {
      value: "big"
    }, "Big")), r.createElement(o.a, {
      id: "items",
      key: "items-json",
      placeholder: t.config.items || [{
        icon: "T",
        primary: "0612345678",
        href: "https://google.nl"
      }],
      height: "550px",
      waitAfterKeyPress: 100,
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        e.jsObject && (t.config.items = e.jsObject, n(s({}, t)));
      }),
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return d;
  });
  var r = n(0),
      a = n(5),
      o = n(1),
      i = n(39),
      l = n(3);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var d = function d(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(l.a)(t.config, function (e) {
      return n(s(s({}, t), {}, {
        config: e
      }));
    }),
        u = c("content", ""),
        d = c("author", ""),
        m = c("color", ""),
        p = c("authorColor", ""),
        g = c("lineTop", !1),
        f = c("font", ""),
        v = Object(o.makeStyles)(function (e) {
      return {
        componentRoot: {
          marginBottom: e.spacing(4)
        },
        iconSmall: {
          marginRight: e.spacing(1)
        },
        propLabel: {
          marginBottom: e.spacing(1),
          fontSize: "0.8em",
          color: "#666"
        },
        colorPicker: {
          width: "100%"
        }
      };
    })();
    return r.createElement(r.Fragment, null, r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Content",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      className: v.componentRoot
    }), r.createElement("div", {
      className: v.componentRoot
    }, r.createElement(o.Typography, {
      gutterBottom: !0,
      className: v.propLabel
    }, "Color"), r.createElement(a.ColorPicker, {
      value: m.value,
      onChange: function onChange(e) {
        m.update(e);
      }
    })), r.createElement(o.TextField, {
      fullWidth: !0,
      label: "Author",
      value: d.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return d.update(e.target.value);
      },
      className: v.componentRoot
    }), r.createElement("div", {
      className: v.componentRoot
    }, r.createElement(o.Typography, {
      gutterBottom: !0,
      className: v.propLabel
    }, "Color Author"), r.createElement(a.ColorPicker, {
      value: p.value,
      onChange: function onChange(e) {
        p.update(e);
      }
    })), r.createElement("div", {
      className: v.componentRoot
    }, r.createElement(o.Typography, {
      gutterBottom: !0,
      className: v.propLabel
    }, "Font"), r.createElement(a.FontSelect, {
      value: f.value,
      onChange: function onChange(e) {
        return f.update(e);
      }
    })), r.createElement("div", {
      className: v.componentRoot
    }, r.createElement(o.FormControlLabel, {
      control: r.createElement(o.Checkbox, {
        checked: g.value,
        onChange: function onChange() {
          return g.update(!g.value);
        }
      }),
      label: "Line on top"
    })), r.createElement(o.Button, {
      variant: "contained",
      size: "small",
      onClick: function onClick() {
        return m.update("inherit");
      }
    }, r.createElement(i.Replay, {
      className: v.iconSmall
    }), "Reset"));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      a = n(1),
      o = n(3);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(o.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    })("items", "");
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Items",
      value: i.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return i.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(1),
      o = n(3),
      i = n(11);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element,
        n = e.onChange,
        l = Object(o.a)(t.config, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        s = l("image", ""),
        u = l("title", ""),
        d = l("index", ""),
        m = l("link", "");
    return r.createElement(r.Fragment, null, r.createElement(i.FileSelector, {
      value: {
        href: s.value
      },
      onChange: function onChange(e) {
        return s.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Title",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Link",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Index",
      value: d.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return d.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      a = n(1),
      o = n(3);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(o.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        c = i("text", ""),
        s = i("color", ""),
        u = i("url", ""),
        d = i("blank", !1);
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Text",
      value: c.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return c.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Color",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "URL",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Target blank?",
      value: d.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(1),
      o = n(4),
      i = n(3);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element,
        n = e.onChange,
        l = Object(i.a)(t.config, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        s = l("category", ""),
        u = l("time", ""),
        d = l("align", "");
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Category",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      label: "Time",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(a.Button, {
      onClick: function onClick() {
        return d.update("flex-start");
      },
      style: "flex-start" === d.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return d.update("center");
      },
      style: "center" === d.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return d.update("flex-end");
      },
      style: "flex-end" === d.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return d;
  });
  var r = n(0),
      a = n(1),
      o = n(4),
      i = n(3),
      l = n(5);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var d = function d(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(l.useTheme)().fonts,
        u = Object(i.a)(t.config, function (e) {
      return n(s(s({}, t), {}, {
        config: e
      }));
    }),
        d = u("gutterBottom", ""),
        m = u("paragraph", ""),
        p = u("children", ""),
        g = u("variant", ""),
        f = u("align", ""),
        v = u("color", ""),
        h = u("endItem", ""),
        b = u("font", ""),
        y = u("fontWeight", ""),
        k = u("fontWeight", "");
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Content",
      value: p.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return p.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(a.Button, {
      onClick: function onClick() {
        return f.update("left");
      },
      style: "left" === f.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return f.update("center");
      },
      style: "center" === f.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return f.update("right");
      },
      style: "right" === f.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(o.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))), r.createElement(a.Typography, {
      style: {
        marginBottom: 10
      }
    }, "Color:"), r.createElement(l.ColorPicker, {
      value: v.value,
      onChange: function onChange(e) {
        v.update(e);
      }
    }), r.createElement(a.Button, {
      onClick: function onClick(e) {
        return v.update("inherit");
      },
      style: {
        marginBottom: 24
      }
    }, "Reset"), r.createElement(a.Typography, null, "Variant:"), r.createElement(l.TypographyVariantSelect, {
      value: g.value,
      onChange: function onChange(e) {
        return g.update(e);
      }
    }), r.createElement("br", null), r.createElement("br", null), r.createElement(a.InputLabel, {
      shrink: !0,
      id: "select-font-label"
    }, "Font"), r.createElement(a.Select, {
      labelId: "select-font-label",
      fullWidth: !0,
      value: b.value,
      onChange: function onChange(e) {
        return b.update(e.target.value);
      },
      style: {
        marginBottom: 20
      }
    }, Object.keys(c || {}).map(function (e) {
      return r.createElement(a.MenuItem, {
        value: e
      }, c[e].name);
    })), r.createElement(a.InputLabel, {
      shrink: !0,
      id: "select-weight-label"
    }, "Font Weight"), r.createElement(a.Typography, null, t.config.fontWeight), r.createElement(a.Slider, {
      defaultValue: y.value,
      step: 100,
      marks: !0,
      min: 100,
      max: 900,
      valueLabelDisplay: "auto",
      onChangeCommitted: function onChangeCommitted(e) {
        return y.update(e && e.target && (parseInt(e.target.innerText) || 300));
      }
    }), r.createElement(a.FormControlLabel, {
      label: "Paragraph",
      control: r.createElement(a.Checkbox, {
        checked: m.value,
        onChange: function onChange() {
          return m.update(!m.value);
        }
      })
    }), r.createElement(a.FormControlLabel, {
      label: "Gutter bottom",
      control: r.createElement(a.Checkbox, {
        checked: d.value,
        onChange: function onChange() {
          return d.update(!d.value);
        }
      })
    }), r.createElement(a.FormControlLabel, {
      label: "endItem",
      control: r.createElement(a.Checkbox, {
        checked: h.value,
        onChange: function onChange() {
          return h.update(!h.value);
        }
      })
    }), h.value && r.createElement(r.Fragment, null, r.createElement(a.InputLabel, {
      id: "label"
    }, "End color"), r.createElement(l.ColorPicker, {
      value: k.value,
      onChange: function onChange(e) {
        return k.update(e);
      }
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return d;
  });
  var r = n(0),
      a = n(1),
      o = n(3),
      i = n(40),
      l = n(4);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var d = function d(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(o.a)(t.config, function (e) {
      return n(s(s({}, t), {}, {
        config: e
      }));
    }),
        u = c("buttonText", "Lees verder"),
        d = c("popupItem", ""),
        m = c("align", ""),
        p = c("yellow", !1),
        g = Object(a.makeStyles)(function (e) {
      return {
        componentRoot: {
          marginBottom: e.spacing(4)
        },
        iconSmall: {
          marginRight: e.spacing(1)
        },
        propLabel: {
          marginBottom: e.spacing(1),
          fontSize: "0.8em",
          color: "#666"
        },
        colorPicker: {
          width: "100%"
        }
      };
    })();
    console.log(u.value);
    u.value;
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Button text",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      className: g.componentRoot
    }), r.createElement(a.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(a.Button, {
      onClick: function onClick() {
        return m.update("flex-start");
      },
      style: "flex-start" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(l.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return m.update("center");
      },
      style: "center" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(l.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(a.Button, {
      onClick: function onClick() {
        return m.update("flex-end");
      },
      style: "flex-end" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(l.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))), r.createElement("br", null), r.createElement(a.FormControlLabel, {
      label: "Yellow color?",
      control: r.createElement(a.Checkbox, {
        checked: p.value,
        onChange: function onChange() {
          return p.update(!p.value);
        }
      })
    }), r.createElement("br", null), r.createElement(a.Select, {
      labelId: "demo-customized-select-label",
      id: "popupItem",
      value: d.value,
      onChange: function onChange(e) {
        return d.update(e.target.value);
      }
    }, Object.keys(i.a).map(function (e) {
      return r.createElement(a.MenuItem, {
        value: e
      }, e);
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      a = n(1),
      o = n(3);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(o.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        c = i("embed", ""),
        s = i("caption", ""),
        u = i("maxWidth", "");
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Embed",
      value: t.config.embed,
      variant: "outlined",
      onChange: function onChange(e) {
        return c.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      label: "Caption",
      value: t.config.caption,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      label: "maxWidth",
      value: t.config.maxWidth,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r = n(0),
      a = n(12),
      o = n.n(a),
      i = n(3),
      l = n(11),
      c = n(1),
      s = n(4);

  function u(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var p = function p(e) {
    var t = e.element,
        n = e.onChange,
        a = Object(i.a)(t.config, function (e) {
      return n(d(d({}, t), {}, {
        config: e
      }));
    }),
        u = a("avatar", ""),
        m = a("align", "");
    return r.createElement(r.Fragment, null, r.createElement(l.FileSelector, {
      value: {
        href: u.value
      },
      onChange: function onChange(e) {
        return u.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(c.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(c.Button, {
      onClick: function onClick() {
        return m.update("flex-start");
      },
      style: "flex-start" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(s.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(c.Button, {
      onClick: function onClick() {
        return m.update("center");
      },
      style: "center" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(s.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(c.Button, {
      onClick: function onClick() {
        return m.update("flex-end");
      },
      style: "flex-end" === m.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(s.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))), r.createElement(o.a, {
      id: "credits",
      key: "credits-json",
      placeholder: t.config.credits || [{
        credit: "Fotografie",
        name: "Name"
      }],
      height: "550px",
      waitAfterKeyPress: 100,
      onChange: function onChange(e) {
        e.jsObject && (t.config.credits = e.jsObject, n(d({}, t)));
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      a = n(1),
      o = n(3);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(o.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        c = i("stepBackground", ""),
        s = i("stepColor", ""),
        u = i("description", ""),
        d = i("title", ""),
        m = i("step", "");
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      label: "Step Background",
      value: c.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return c.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      label: "Step Color",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      label: "Step",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Title",
      value: d.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return d.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Description",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });

  var r = n(0),
      a = n(12),
      o = n.n(a),
      i = function i(e) {
    var t = e.element,
        n = e.onChange;
    return r.createElement(o.a, {
      id: "json-" + t.id,
      placeholder: t.config,
      height: "550px",
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        e && e.jsObject && (t.config = e.jsObject, n(t));
      }),
      style: {
        marginBottom: 12
      }
    });
  };
}, function (e, t) {}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });
  var r = n(1),
      a = n(0),
      o = n(21);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var c = function c(e) {
    var t = e.template;
    if (!t || !t.component) return null;

    var n = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? i(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, o.a)[t.component];

    return n ? a.createElement(n, {
      template: t
    }) : a.createElement(r.Typography, null, "Template ", t.component, " not available");
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  }), n.d(t, "b", function () {
    return c;
  });
  var r = n(64),
      a = n.n(r);

  function o(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function l(e) {
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? o(Object(n), !0).forEach(function (t) {
          i(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      id: a()(),
      component: e.component || "default",
      config: e.config || {}
    }, e);
  }

  function c() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return l(e);
  }
}, function (e, t) {}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      a = n(3),
      o = n(16),
      i = n(9);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.template,
        n = e.onChange,
        l = Object(a.a)(t.config || {}, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        s = (l("companyLogo", ""), l("exampleImage", {
      config: {
        caption: "",
        src: "/assets/images/carmel/logo.svg"
      },
      component: "Image"
    }));
    return r.createElement(r.Fragment, null, r.createElement(o.a, {
      element: Object(i.a)(s.value),
      onChange: function onChange(e) {
        s.update(e);
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });

  var r = n(0),
      a = n(41),
      o = n.n(a),
      i = n(1),
      l = n(6),
      c = n(65),
      s = n.n(c),
      u = n(5),
      d = Object(a.WidthProvider)(o.a),
      m = Object(i.makeStyles)({
    root: {
      width: "100%",
      "& .react-grid-item": {
        touchAction: "auto !important"
      }
    }
  }),
      p = function p(e) {
    var t = e.layout,
        n = e.elements,
        a = e.containerPadding,
        o = e.rowHeight,
        c = e.margin,
        p = e.cols,
        g = (e.theme, e.editable, m()),
        f = r.useRef(null),
        v = Object(u.useTheme)().MuiTheme;
    return p = p || 24, o = o || 12, c = c || [24, 0], a = a || [0, 0], !0, n || (n = []), r.createElement(i.ThemeProvider, {
      theme: v
    }, r.createElement(s.a, null), r.createElement("div", {
      className: g.root
    }, r.createElement(d, {
      layout: t,
      isResizable: !0,
      isDraggable: !0,
      isDroppable: !0,
      margin: c,
      cols: p,
      rowHeight: o,
      containerPadding: a
    }, n.map(function (e) {
      return r.createElement("div", {
        key: e.id,
        "data-grid": e.layout
      }, r.createElement("div", {
        ref: f,
        style: {
          padding: 1
        }
      }, r.createElement(l.a, {
        element: e
      })));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });

  var r = n(1),
      a = n(0),
      o = Object(r.makeStyles)(function (e) {
    return {
      printBtn: {
        position: "fixed",
        right: e.spacing(4),
        top: e.spacing(8),
        "@media print": {
          display: "none"
        }
      },
      root: {
        fontSize: "1rem",
        "@media screen": {
          minHeight: "100vh",
          padding: e.spacing(4, 2, 8, 2),
          backgroundColor: "#eee"
        }
      },
      page: {
        "@media screen": {
          position: "relative",
          margin: "auto",
          maxWidth: 900,
          width: "100vw",
          padding: "60px",
          background: "#fff"
        }
      },
      content: {
        color: "#000",
        background: "#fff",
        "& > *, & h1, & h2, & h3, & h4, & h5, & h6, & p": {
          margin: "1rem 0 0.5rem 0"
        },
        "& h1, & h2, & h3, & h4, & h5, & h6": {
          margin: "1rem 0 0.5rem 0",
          "& + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
            marginTop: "-0.5em"
          }
        },
        "& p": {
          lineHeight: 1.33,
          fontSize: "0.9em"
        },
        "& h1": {
          lineHeight: 1.33,
          fontSize: "3em"
        },
        "& h2": {
          lineHeight: 1.33,
          fontSize: "2.5em"
        },
        "& h3": {
          lineHeight: 1.33,
          fontSize: "1.8em"
        },
        "& h4": {
          lineHeight: 1.33,
          fontSize: "1.4em"
        },
        "& h5": {
          lineHeight: 1.33,
          fontSize: "1.2em"
        },
        "& h6": {
          lineHeight: 1.33,
          fontSize: "1.1em"
        },
        "& *": {
          color: "#000 !important",
          background: "none !important"
        },
        "& iframe, & br, & video": {
          display: "none"
        }
      }
    };
  }),
      i = function i(e) {
    var t = e.children,
        n = o();
    return a.createElement(a.Fragment, null, a.createElement(r.Button, {
      className: n.printBtn,
      onClick: function onClick() {
        window.print();
      },
      variant: "contained",
      color: "primary"
    }, "PRINT"), a.createElement("div", {
      className: n.root
    }, a.createElement("div", {
      className: n.page
    }, a.createElement("div", {
      className: n.content
    }, t))));
  };
}, function (e, t) {
  e.exports = require("@fortawesome/free-solid-svg-icons");
}, function (e, t) {
  e.exports = require("@material-ui/styles");
}, function (e, t) {
  e.exports = require("@material-ui/icons/HighlightOff");
}, function (e, t) {
  e.exports = require("uuid/v4");
}, function (e, t) {
  e.exports = require("@material-ui/core/ScopedCssBaseline");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(15);
  n.d(t, "ImageComponent", function () {
    return r.a;
  });
  var a = n(16);
  n.d(t, "FormImageElement", function () {
    return a.a;
  });
  var o = n(23);
  n.d(t, "ListComponent", function () {
    return o.a;
  });
  var i = n(42);
  n.d(t, "FormListElement", function () {
    return i.a;
  });
  var l = n(17);
  n.d(t, "MediaComponent", function () {
    return l.a;
  });
  var c = n(24);
  n.d(t, "PaperComponent", function () {
    return c.a;
  });
  var s = n(26);
  n.d(t, "QuoteComponent", function () {
    return s.a;
  });
  var u = n(43);
  n.d(t, "FormQuoteElement", function () {
    return u.a;
  });
  var d = n(33);
  n.d(t, "IndexComponent", function () {
    return d.a;
  });
  var m = n(44);
  n.d(t, "FormIndexElement", function () {
    return m.a;
  });
  var p = n(30);
  n.d(t, "CoverButtonComponent", function () {
    return p.a;
  });
  var g = n(45);
  n.d(t, "FormCoverButtonElement", function () {
    return g.a;
  });
  var f = n(31);
  n.d(t, "ButtonComponent", function () {
    return f.a;
  });
  var v = n(46);
  n.d(t, "FormButtonElement", function () {
    return v.a;
  });
  var h = n(29);
  n.d(t, "DividerComponent", function () {
    return h.a;
  });
  var b = n(18);
  n.d(t, "ReadTimeComponent", function () {
    return b.a;
  });
  var y = n(47);
  n.d(t, "FormReadTimeElement", function () {
    return y.a;
  });
  var k = n(25);
  n.d(t, "TypographyComponent", function () {
    return k.a;
  });
  var E = n(48);
  n.d(t, "FormTypographyElement", function () {
    return E.a;
  });
  var j = n(19);
  n.d(t, "TypographyPrintComponent", function () {
    return j.a;
  });
  var O = n(32);
  n.d(t, "PopupComponent", function () {
    return O.a;
  });
  var w = n(49);
  n.d(t, "FormPopupElement", function () {
    return w.a;
  });
  var z = n(28);
  n.d(t, "VideoComponent", function () {
    return z.a;
  });
  var x = n(50);
  n.d(t, "FormVideoElement", function () {
    return x.a;
  });
  var T = n(27);
  n.d(t, "AuthorComponent", function () {
    return T.a;
  });
  var S = n(51);
  n.d(t, "FormAuthorElement", function () {
    return S.a;
  });
  var P = n(22);
  n.d(t, "WistJeDatComponent", function () {
    return P.a;
  });
  var C = n(52);
  n.d(t, "FormWistJeDatElement", function () {
    return C.a;
  });
  var D = n(13);
  n.d(t, "ElementType", function () {
    return D.a;
  }), n.d(t, "defaultComponents", function () {
    return D.b;
  }), n.d(t, "defaultPrintComponents", function () {
    return D.c;
  });
  var F = n(6);
  n.d(t, "RenderElement", function () {
    return F.a;
  });
  var B = n(53);
  n.d(t, "FormJson", function () {
    return B.a;
  });
  var M = n(9);
  n.d(t, "transformRecord", function () {
    return M.c;
  }), n.d(t, "generateLayout", function () {
    return M.b;
  }), n.d(t, "createElement", function () {
    return M.a;
  }), n.d(t, "useElement", function () {
    return M.d;
  });
  var A = n(54);

  for (var I in A) {
    ["default", "ImageComponent", "FormImageElement", "ListComponent", "FormListElement", "MediaComponent", "PaperComponent", "QuoteComponent", "FormQuoteElement", "IndexComponent", "FormIndexElement", "CoverButtonComponent", "FormCoverButtonElement", "ButtonComponent", "FormButtonElement", "DividerComponent", "ReadTimeComponent", "FormReadTimeElement", "TypographyComponent", "FormTypographyElement", "TypographyPrintComponent", "PopupComponent", "FormPopupElement", "VideoComponent", "FormVideoElement", "AuthorComponent", "FormAuthorElement", "WistJeDatComponent", "FormWistJeDatElement", "ElementType", "defaultComponents", "defaultPrintComponents", "RenderElement", "FormJson", "transformRecord", "generateLayout", "createElement", "useElement"].indexOf(I) < 0 && function (e) {
      n.d(t, e, function () {
        return A[e];
      });
    }(I);
  }

  var N = n(21);
  n.d(t, "defaultTemplates", function () {
    return N.a;
  });
  var R = n(55);
  n.d(t, "RenderTemplate", function () {
    return R.a;
  });
  var W = n(56);
  n.d(t, "createTemplate", function () {
    return W.a;
  }), n.d(t, "useTemplate", function () {
    return W.b;
  });
  var H = n(57);

  for (var I in H) {
    ["default", "ImageComponent", "FormImageElement", "ListComponent", "FormListElement", "MediaComponent", "PaperComponent", "QuoteComponent", "FormQuoteElement", "IndexComponent", "FormIndexElement", "CoverButtonComponent", "FormCoverButtonElement", "ButtonComponent", "FormButtonElement", "DividerComponent", "ReadTimeComponent", "FormReadTimeElement", "TypographyComponent", "FormTypographyElement", "TypographyPrintComponent", "PopupComponent", "FormPopupElement", "VideoComponent", "FormVideoElement", "AuthorComponent", "FormAuthorElement", "WistJeDatComponent", "FormWistJeDatElement", "ElementType", "defaultComponents", "defaultPrintComponents", "RenderElement", "FormJson", "transformRecord", "generateLayout", "createElement", "useElement", "defaultTemplates", "RenderTemplate", "createTemplate", "useTemplate"].indexOf(I) < 0 && function (e) {
      n.d(t, e, function () {
        return H[e];
      });
    }(I);
  }

  var V = n(34);
  n.d(t, "DefaultCoverTemplateComponent", function () {
    return V.a;
  });
  var L = n(58);
  n.d(t, "FormDefaultCoverTemplate", function () {
    return L.a;
  });
  var G = n(59);
  n.d(t, "GreenzeenContent", function () {
    return G.a;
  });
  var Z = n(60);
  n.d(t, "PrintContainer", function () {
    return Z.a;
  });
  var U = n(20);
  n.d(t, "Content", function () {
    return U.a;
  });
}]));